<template>
  <div class="page-container">
    <div class="head" v-if="!embedded">
      <div class="head-title">
        <img src="../../static/img/logo.png" class="head-logo" />
        景区旅游大数据中心
      </div>
      <div class="head-type">
        <div class="type-item" v-for="(item, index) in navItems" :key="index"
          :class="{ 'type-item2': index === activeNavIndex }" @click="typeChange(item)">
          {{ item.label }}
          <div class="type-on" v-if="index === activeNavIndex"></div>
        </div>
      </div>
      <div>
        <div class="date-weather">
          <div class="changeDateOne" @click="changeTheDate(-1)">前一天</div>
          <div class="changeDateOne" @click="changeTheDate(0)">&nbsp;&nbsp;</div>
          <div class="changeDateOne" @click="changeTheDate(1)">后一天</div>
          <img @click="refreshPage" src="../../static/img/refresh-ccw.png" style="
              display: inline-block;
              width: 14px;
              height: 14px;
              vertical-align: middle;
              transform: translate(0, -2px);
              cursor: pointer;
            " v-if="isToday" />
          {{ isToday ? nowDay : req_date.replace('-', '/') }} {{ isToday ? week : changeWeek }} {{ isToday ? nowTime :
            '' }}
        </div>
      </div>
    </div>

    <div class="warning-main" :class="{ 'embedded-mode': embedded }">
      <div :id="mapId" class="migrateMap"></div>

      <div class="warning-left">
        <div class="data-box monitor-panel">
          <!-- <div class="monitor-title">
            <span class="title-text">监控操作</span>
            <button class="maintenance-btn-mini" :class="{ active: isMaintenancePanelOpen }"
              @click="toggleMaintenancePanel">
              <span class="mini-icon">⚙️</span>
              <span class="mini-badge" v-if="abnormalChannelCount > 0">{{ abnormalChannelCount }}</span>
            </button>
          </div> -->
          <!-- 监控点位统计 -->
          <div class="filter-section">
            <div class="filter-row">
              <div class="filter-item">
                <span class="filter-label">监控布局</span>
                <div class="filter-select-box">
                  <select class="filter-select" v-model="currentScreenCount"
                    @change="changeScreenCount(currentScreenCount)">
                    <option :value="0">无</option>
                    <option :value="1">1 屏</option>
                    <option :value="4">4 屏</option>
                    <option :value="9">9 屏</option>
                    <option :value="16">16 屏</option>
                    <option :value="64">64 屏</option>
                  </select>
                  <span class="select-arrow">▼</span>
                </div>
              </div>
              <div class="filter-item">
                <span class="filter-label">区域筛选</span>
                <div class="filter-select-box">
                  <select class="filter-select" v-model="filterRegion">
                    <option value="">全部</option>
                    <option value="弦高古城">弦高古城</option>
                    <option value="篁岭">篁岭</option>
                    <option value="卧龙谷">卧龙谷</option>
                    <option value="婺女州">婺女州</option>
                    <option value="月亮湾">月亮湾</option>
                  </select>
                  <span class="select-arrow">▼</span>
                </div>
              </div>

              <div class="filter-item">
                <span class="filter-label">类型筛选</span>
                <div class="filter-select-box">
                  <select class="filter-select" v-model="filterType">
                    <option value="">全部</option>
                    <option value="入口">入口</option>
                    <option value="出口">出口</option>
                    <option value="景点">景点</option>
                    <option value="停车场">停车场</option>
                    <option value="设施">设施</option>
                    <option value="广场">广场</option>
                    <option value="道路">道路</option>
                    <option value="商业">商业</option>
                  </select>
                  <span class="select-arrow">▼</span>
                </div>
              </div>
              <div class="filter-item">
                <span class="filter-label">状态筛选</span>
                <div class="filter-select-box">
                  <select class="filter-select" v-model="filterStatus">
                    <option value="">全部</option>
                    <option value="online">在线</option>
                    <option value="offline">离线</option>
                    <option value="error">异常</option>
                  </select>
                  <span class="select-arrow">▼</span>
                </div>
              </div>
            </div>
          </div>
          <div class="video-points-stats">
            <div class="stats-item">
              <span class="stats-icon online-icon"></span>
              <span class="stats-label">在线</span>
              <span class="stats-count">{{ onlineCount }}</span>
            </div>
            <div class="stats-item">
              <span class="stats-icon offline-icon"></span>
              <span class="stats-label">离线</span>
              <span class="stats-count">{{ offlineCount }}</span>
            </div>
            <div class="stats-item">
              <span class="stats-icon error-icon"></span>
              <span class="stats-label">异常</span>
              <span class="stats-count">{{ errorCount }}</span>
            </div>
            <div class="stats-item">
              <span class="stats-icon total-icon"></span>
              <span class="stats-label">总计</span>
              <span class="stats-count">{{ totalCount }}</span>
            </div>
          </div>
          <!-- 监控列表区域 -->
          <div class="timeline-section">
            <div class="section-title">监控列表</div>
            <div class="timeline-list">
              <div v-for="group in groupedVideoPoints" :key="group.region" class="region-group">
                <!-- 景区折叠头部 -->
                <div class="region-header" @click="toggleRegion(group.region)"
                  :class="{ 'region-expanded': expandedRegion === group.region }">
                  <span class="region-arrow">{{ expandedRegion === group.region ? '&#9662;' : '&#9656;' }}</span>
                  <span class="region-name">{{ group.region }}</span>
                  <span class="region-count">{{ group.onlineCount }}/{{ group.totalCount }}</span>
                  <span class="region-event-count" v-if="group.eventCount > 0">{{ group.eventCount }} 事件</span>
                </div>
                <!-- 展开时显示监控点 + 事件 -->
                <div v-if="expandedRegion === group.region" class="region-body">
                  <div class="timeline-item" v-for="point in group.points" :key="point.id"
                    @click="selectPoint(point)" :draggable="!!point.url"
                    @dragstart="onDragPointStart($event, point)" @dragend="onDragPointEnd">
                    <div class="timeline-dot" :class="'dot-' + point.status"></div>
                    <div class="timeline-content">{{ point.name }}</div>
                  </div>
                  <!-- 该景区的事件回溯 -->
                  <div v-if="regionTimeline.length > 0" class="region-events">
                    <div class="events-title">事件回溯</div>
                    <div class="timeline-item" v-for="(item, idx) in regionTimeline" :key="'evt-' + idx"
                      @click="openVideoPlayback(item)">
                      <span class="timeline-time">{{ item.time }}</span>
                      <span class="timeline-dot" :class="'dot-' + (item.type || 'normal')"></span>
                      <span class="timeline-content">{{ item.content }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="groupedVideoPoints.length === 0" class="empty-tip">
                暂无符合条件的监控点位
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 视频回放弹窗 -->
      <div class="video-playback-modal" v-if="isPlaybackModalOpen">
        <div class="modal-overlay" @click="closePlaybackModal"></div>
        <div class="modal-content playback-modal">
          <div class="modal-header-row">
            <div class="modal-title">事件回溯</div>
            <button class="modal-close-btn" @click="closePlaybackModal">
              <span class="close-icon">&times;</span>
            </button>
          </div>
          <div class="modal-body-grid">
            <div class="main-content-area">
              <div class="video-wrapper">
                <div class="video-header">
                  <span class="video-label">视频播放</span>
                  <span class="video-duration">{{ currentEvent.startTime }} - {{ currentEvent.endTime }}</span>
                </div>
                <video ref="playbackVideo" :src="playbackVideoUrl" class="playback-video" controls autoplay muted
                  playsinline></video>
              </div>
            </div>
            <div class="side-panel">
              <div class="info-card">
                <div class="card-header">
                  <span class="card-title">事件详情</span>
                </div>
                <div class="card-body">
                  <div class="detail-item">
                    <div class="detail-label">事件类型</div>
                    <div class="detail-value-wrapper">
                      <span class="detail-badge" :class="'type-' + currentEvent.type">{{ currentEvent.content }}</span>
                    </div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">发生时间</div>
                    <div class="detail-value">{{ currentEvent.time }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="detail-label">回放时段</div>
                    <div class="detail-value">{{ currentEvent.startTime }} — {{ currentEvent.endTime }}</div>
                  </div>
                </div>
              </div>
              <div class="export-card">
                <div class="card-header">
                  <span class="card-title">片段导出</span>
                </div>
                <div class="card-body">
                  <div class="export-form">
                    <div class="form-item">
                      <label class="form-label">开始时间</label>
                      <input type="datetime-local" class="datetime-input" v-model="exportStartTime" />
                    </div>
                    <div class="form-item">
                      <label class="form-label">结束时间</label>
                      <input type="datetime-local" class="datetime-input" v-model="exportEndTime" />
                    </div>
                    <button class="export-button" @click="exportVideo">导出视频片段</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 点位视频播放弹窗 -->
      <div class="point-video-modal" v-if="isPointVideoModalOpen">
        <div class="modal-overlay" @click="closePointVideoModal"></div>
        <div class="modal-content point-modal">
          <div class="modal-header-row">
            <div class="modal-title">{{ currentPlayPoint && currentPlayPoint.name || '监控视频' }}</div>
            <button class="modal-close-btn" @click="closePointVideoModal">
              <span class="close-icon">&#10005;</span>
            </button>
          </div>
          <div class="modal-body-container">
            <div class="video-main-area">
              <div class="video-display-area" v-if="currentPlayPoint && currentPlayPoint.status === 'online'">
                <div id="pointVideoContainer" class="point-video-player"></div>
                <div class="video-controls-overlay">
                  <span class="live-badge">LIVE</span>
                </div>
              </div>
              <div class="video-display-area offline-state" v-else>
                <div class="offline-display">
                  <div class="offline-title">{{ currentPlayPoint && currentPlayPoint.statusText || '监控异常' }}</div>
                  <div class="offline-desc">该监控点位当前无法访问，请稍后重试</div>
                </div>
              </div>
            </div>
            <div class="info-sidebar">
              <div class="info-panel">
                <div class="panel-header">
                  <span class="panel-title">点位信息</span>
                </div>
                <div class="panel-content">
                  <div class="info-row-item">
                    <span class="info-label">所属区域</span>
                    <span class="info-value">{{ currentPlayPoint && currentPlayPoint.region || '-' }}</span>
                  </div>
                  <div class="info-row-item">
                    <span class="info-label">设备类型</span>
                    <span class="info-value">{{ currentPlayPoint && currentPlayPoint.type || '-' }}</span>
                  </div>
                  <div class="info-row-item">
                    <span class="info-label">设备状态</span>
                    <span class="info-value">
                      <span class="status-dot"
                        :class="(currentPlayPoint && currentPlayPoint.status === 'online') ? 'dot-online' : 'dot-offline'"></span>
                      {{ currentPlayPoint && currentPlayPoint.statusText || '未知' }}
                    </span>
                  </div>
                  <div class="info-row-item">
                    <span class="info-label">设备编号</span>
                    <span class="info-value">{{ currentPlayPoint && currentPlayPoint.id || '-' }}</span>
                  </div>
                </div>
              </div>
              <div class="action-panel">
                <button class="action-btn primary" @click="refreshVideoStream">刷新视频</button>
                <button class="action-btn secondary" @click="closePointVideoModal">关闭窗口</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 运维看板面板 -->

      <div class="warning-right" v-if="currentScreenCount > 0" :class="{ 'collapsed': !isPanelExpanded }">
        <div class="data-box screen-preview-panel">
          <!-- 可点击的标题栏，用于展开/隐藏 -->
          <!-- <div class="monitor-toggle-header" @click="togglePanel">
            <div class="monitor-title">实时监控</div>
            <div class="toggle-icon">{{ isPanelExpanded ? '◀' : '▶' }}</div>
          </div> -->

          <!-- 监控内容区域 -->
          <div class="monitor-content" :class="{ 'show': isPanelExpanded }">
            <!-- 1屏时使用FLV播放器 -->
            <div v-if="currentScreenCount === 1" class="single-screen-container" :style="getGridItemStyle()">
              <div class="screen-video-wrapper" style="width: 46.74vh; height: 26.2912vh">
                <div class="screen-video-body" style="width: 46.74vh; height: 26.2912vh">
                  <div id="singleScreenContainer"></div>
                </div>
              </div>
            </div>
            <!-- 多屏时使用原来的网格布局 -->
            <div v-else class="screen-grid" :style="getGridStyle()">
              <div class="screen-grid-item" v-for="(n, index) in screenGridCount" :key="index"
                :style="getGridItemStyle()"
                :class="{ 'is-dragging': dragIndex === index, 'is-drag-over': dragOverIndex === index, 'is-drop-target': dropTargetIndex === index }"
                @mousedown="startDrag($event, index)"
                @dragover.prevent="onDropZoneOver($event, index)" @dragleave="onDropZoneLeave"
                @drop="onDropPoint($event, index)">
                <div class="screen-video-wrapper">
                  <div class="screen-video-body">
                    <video :ref="'screenVideo' + index" :src="getVideoUrl(index)"
                      :key="'video-' + index + '-' + (getScreenPoint(index) ? getScreenPoint(index).id : 'default')"
                      class="screen-video" autoplay muted playsinline loop></video>
                  </div>
                </div>
                <!-- 拖拽视觉反馈覆盖层 -->
                <div class="drag-overlay">
                  <div class="drag-overlay-icon">
                    <span v-if="dragOverIndex === index" class="drag-label-text">释放交换</span>
                    <span v-else-if="dropTargetIndex === index" class="drag-label-text">释放替换</span>
                    <span v-else class="drag-label-text">拖拽交换</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 数据传输通道状态 -->
          <div class="timeline-section" style="margin-top: 10px;">
            <div class="section-title">传输通道</div>
            <div class="channel-status-list timeline-list">
              <div class="timeline-item" v-for="channel in channelStatusList" :key="channel.id">
                <div class="timeline-dot" :class="getChannelStatusClass(channel.status)"></div>
                <div class="channel-info-content">
                  <div class="timeline-content">{{ channel.name }}</div>
                  <div class="channel-device-text">设备：{{ channel.device }}</div>
                </div>
                <div class="channel-status-badge" :class="getChannelStatusClass(channel.status)">
                  {{ getChannelStatusText(channel.status) }}
                </div>
                <div class="channel-time-text">{{ channel.lastReportTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/index'
import { getSettingByIdApi } from '../api/ScenicAPI'

const WUYUAN_CENTER = {
  lat: 29.254015,
  lng: 117.861488
}

const WUYUAN_BOUNDARY_LOCAL_URL = process.env.NODE_ENV === 'production'
  ? '/static/big_data_web/geo/361130.json'
  : '/static/geo/361130.json'
const WUYUAN_BOUNDARY_REMOTE_URL = 'https://geo.datav.aliyun.com/areas_v3/bound/361130.json'
const WUYUAN_BOUNDARY_URLS = [WUYUAN_BOUNDARY_LOCAL_URL, WUYUAN_BOUNDARY_REMOTE_URL]
const WUYUAN_VIEW_HORIZONTAL_PADDING_RATIO = 0.38
const WUYUAN_VIEW_VERTICAL_PADDING_RATIO = 0.18

export default {
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      navItems: [
        { label: '文旅市场', path: '/', query: { typeIndex: 0 } },
        { label: '客流分析', path: '/scenic_date_data', query: { typeIndex: 0 } },
        { label: '大数据驾驶舱', path: '/', query: { typeIndex: 2 } },
        { label: '客流预警', path: '/scenic_warning', query: {} }
      ],
      activeNavIndex: 3,
      scenic_id: '',
      req_date: null,
      isToday: true,
      nowDay: '',
      nowDay2: '',
      nowTime: '',
      week: '',
      changeWeek: '',
      hour: '',
      weather: {},
      warningRecordCount: 10,
      recordVisible: true,
      timelineData: [
        { time: '06-08 17:35:12', content: '设备故障', type: 'fault', region: '月亮湾', videoUrl: '/static/mp4/10.mp4', startTime: '2026-06-08 17:30:00', endTime: '2026-06-08 17:45:00' },
        { time: '06-08 22:00:30', content: '客流拥堵', type: 'congestion', region: '月亮湾', videoUrl: '', startTime: '2026-06-08 21:55:00', endTime: '2026-06-08 22:10:00' }
      ],

      mapId: 'sentimentMap',
      setting: {
        map_show: 5,
        lat_offset: 0,
        lng_offset: 0
      },
      map: null,
      currentScreenCount: 0,
      isPanelExpanded: true, // 控制实时监控面板的展开/隐藏状态
      dragIndex: -1, // 当前拖拽的索引
      dragOverIndex: -1, // 当前拖拽经过的索引
      isDraggingPoint: false, // 是否正在拖拽点位
      draggingPoint: null, // 当前拖拽的点位
      dropTargetIndex: -1, // 当前拖拽目标屏幕索引
      isMaintenancePanelOpen: false, // 运维看板面板是否打开
      expandedRegion: null, // 当前展开的景区（null表示全部收起）
      isPlaybackModalOpen: false, // 视频回放弹窗是否打开
      filterRegion: '', // 区域筛选
      filterType: '', // 类型筛选
      filterStatus: '', // 状态筛选
      isPointVideoModalOpen: false, // 点位视频播放弹窗是否打开
      currentEvent: {}, // 当前选中的事件
      currentPoint: null, // 当前选中的监控点位
      playbackVideoUrl: '', // 回放视频地址
      screenVideoSources: [], // 每个屏幕的视频源配置 [{ screenIndex, pointId, url }]
      screenFlvPlayers: {}, // 存储各屏幕的FLV播放器实例
      exportStartTime: '', // 导出开始时间
      exportEndTime: '', // 导出结束时间
      channelStatusList: [ // 数据传输通道状态列表
        { id: 1, name: '大门入口-光纤链路', status: 'normal', lastReportTime: '2026-06-09 10:32:18', device: '海康DS-3T47GWD-L  IPC-01' },
        { id: 2, name: '售票处-光纤链路', status: 'normal', lastReportTime: '2026-06-09 10:32:15', device: '海康DS-2CD3T47G2  IPC-04' },
        { id: 3, name: '中心广场-光纤链路', status: 'normal', lastReportTime: '2026-06-09 10:32:20', device: '大华DH-IPC-HFW5442T  IPC-13' },
        { id: 4, name: '主干道-4G无线链路', status: 'abnormal', lastReportTime: '2026-06-09 09:48:33', device: '海康DS-2DE4A425IW  IPC-11' },
        { id: 5, name: '篁岭景区-光纤专线', status: 'normal', lastReportTime: '2026-06-09 10:32:12', device: 'H3C S5130S-28P-EI  SW-HL01' },
        { id: 6, name: '停车场A-无线网桥', status: 'offline', lastReportTime: '2026-06-08 16:22:41', device: 'TP-LINK CPE510  BR-07' },
        { id: 7, name: '古建筑群-光纤链路', status: 'normal', lastReportTime: '2026-06-09 10:32:08', device: '大华DH-IPC-HDW2831T  IPC-17' },
        { id: 8, name: '观景台-4G无线链路', status: 'normal', lastReportTime: '2026-06-09 10:31:55', device: '海康DS-2CD2T47G2  IPC-16' },
        { id: 9, name: '油菜花田-无线网桥', status: 'abnormal', lastReportTime: '2026-06-09 08:15:22', device: 'Ubiquiti NanoStation  BR-18' },
        { id: 10, name: 'NVR存储-核心链路', status: 'normal', lastReportTime: '2026-06-09 10:32:25', device: '海康DS-8632N-K8  NVR-01' }
      ],
      boundaryLayer: null,
      boundaryGeometries: [],
      boundaryBounds: null,
      viewportBounds: null,
      markerLayer: null,
      videoPoints: [
        'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000011.flv',
        'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000007.flv',
      ],
      statusIcons: {
        online: null,
        offline: null,
        error: null
      },
      // 当前播放的点位
      currentPlayPoint: null,
      // FLV播放器实例
      videoPlayers: [],
      // 点位视频播放器实例
      pointVideoPlayer: null,
      // 单屏模式下的Jessibuca播放器实例
      singleScreenJessibuca: null,

      clockTimer: null,
    }
  },
  mounted() {
    console.log('video-surveillance mounted')
    console.log('Drag methods available:', {
      onDragPointStart: typeof this.onDragPointStart,
      onDragPointEnd: typeof this.onDragPointEnd,
      onDropPoint: typeof this.onDropPoint
    })
    if (!this.$route.query.id) {
      const id = sessionStorage.getItem('scenicId')
      this.$router.push({ path: '/scenic_warning', query: { id: id, token: store.state.token } })
      this.$router.go(0)
      return
    }

    this.scenic_id = this.$route.query.id
    this.getToday()

    if (this.$route.query.date) {
      this.req_date = this.$route.query.date
      if (this.req_date) {
        const reDate = new Date(this.req_date)
        this.changeWeek = this.getWeek(reDate.getDay())
      }
    }

    if (this.$route.query.token) {
      this.$store.commit('setToken', this.$route.query.token)
    }

    this.isToday = !(this.req_date && this.req_date !== '' && this.req_date !== this.nowDay2)
    this.startClock()

    // 初始化状态图标（使用SVG圆形图标）
    this.statusIcons = {
      online: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><circle cx="10" cy="10" r="8" fill="#52c41a" stroke="#fff" stroke-width="1.5"/></svg>'),
      offline: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><circle cx="10" cy="10" r="8" fill="#8c8c8c" stroke="#fff" stroke-width="1.5"/></svg>'),
      error: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><circle cx="10" cy="10" r="8" fill="#ff4d4f" stroke="#fff" stroke-width="1.5"/></svg>')
    }

    this.$nextTick(() => {
      setTimeout(() => {
        this.renderWuyuanHeatMap()
      }, 300)

      // 初始化视频播放器
      setTimeout(() => {
        this.initVideoPlayers()
      }, 500)
    })
  },
  computed: {
    screenGridCount() {
      return Array.from({ length: this.currentScreenCount }, (_, i) => i + 1)
    },
    abnormalChannelCount() {
      return this.channelStatusList.filter(channel => channel.status === 'abnormal' || channel.status === 'offline').length
    },
    // 统计各状态点位数量
    onlineCount() {
      return this.videoPoints.filter(point => point.status === 'online').length
    },
    offlineCount() {
      return this.videoPoints.filter(point => point.status === 'offline').length
    },
    errorCount() {
      return this.videoPoints.filter(point => point.status === 'error').length
    },
    totalCount() {
      return this.videoPoints.length
    },
    // 根据屏数动态计算右侧面板宽度（自适应，最大90vh由CSS控制）
    rightPanelWidth() {
      // 返回auto，让元素根据内容自动调整宽度
      // 最大宽度由CSS的max-width: 90vh控制
      return 'auto'
    },
    // 根据屏数动态计算右侧面板高度（自适应，最大90vh由CSS控制）
    rightPanelHeight() {
      // 返回auto，让元素根据内容自动调整高度
      // 最大高度由CSS的max-height: 90vh控制
      return 'auto'
    },
    // 筛选后的监控点位列表
    filteredVideoPoints() {
      return this.videoPoints.filter(point => {
        if (this.filterRegion && point.region !== this.filterRegion) {
          return false
        }
        if (this.filterType && point.type !== this.filterType) {
          return false
        }
        if (this.filterStatus && point.status !== this.filterStatus) {
          return false
        }
        return true
      })
    },
    // 按景区分组的监控点位
    groupedVideoPoints() {
      const allRegions = ['弦高古城', '篁岭', '卧龙谷', '婺女州', '月亮湾']
      const groups = {}
      allRegions.forEach(region => { groups[region] = [] })
      this.filteredVideoPoints.forEach(point => {
        const region = point.region || '未分组'
        if (!groups[region]) {
          groups[region] = []
        }
        groups[region].push(point)
      })
      const self = this
      return allRegions.map(region => ({
        region: region,
        points: groups[region] || [],
        onlineCount: (groups[region] || []).filter(p => p.status === 'online').length,
        totalCount: (groups[region] || []).length,
        eventCount: self.timelineData.filter(e => e.region === region).length
      }))
    },
    // 当前展开景区的事件回溯数据
    regionTimeline() {
      if (!this.expandedRegion) return []
      return this.timelineData.filter(item => item.region === this.expandedRegion)
    },
    // 筛选后的点位数量
    filteredPointsCount() {
      return this.filteredVideoPoints.length
    }
  },
  beforeDestroy() {
    if (this.clockTimer) {
      clearInterval(this.clockTimer)
      this.clockTimer = null
    }
    if (this.boundaryLayer && this.boundaryLayer.setMap) {
      this.boundaryLayer.setMap(null)
      this.boundaryLayer = null
    }
    if (this.markerLayer && this.markerLayer.setMap) {
      this.markerLayer.setMap(null)
      this.markerLayer = null
    }
    if (this.textLayer && this.textLayer.setMap) {
      this.textLayer.setMap(null)
      this.textLayer = null
    }
    if (this.map && this.map.destroy) {
      this.map.destroy()
      this.map = null
    }
    // 销毁视频播放器
    this.destroyVideoPlayers()
    // 销毁点位视频播放器
    this.destroyPointVideoPlayer()
    // 销毁单屏播放器
    this.destroySingleScreenPlayer()
    // 销毁所有屏幕FLV播放器
    this.destroyAllScreenFlvPlayers()
  },
  watch: {
    filterRegion() {
      this.applyFilter()
    },
    filterType() {
      this.applyFilter()
    },
    filterStatus() {
      this.applyFilter()
    }
  },
  methods: {
    // 获取视频名称
    getVideoName(index) {
      const onlinePoints = this.getFilteredPoints().filter(p => p.status === 'online')
      if (index < onlinePoints.length) {
        return onlinePoints[index].name
      }
      return `监控${index + 1}`
    },
    // 获取视频流地址
    getVideoUrl(index) {
      // 检查是否有自定义视频源配置
      const sourceConfig = this.screenVideoSources.find(s => s.screenIndex === index)
      if (sourceConfig && sourceConfig.url) {
        return sourceConfig.url
      }
      // 默认使用本地静态视频
      // 1-16 屏按顺序播放，超过 16 屏的随机播放
      let videoNumber
      if (index < 16) {
        videoNumber = index + 1
      } else {
        videoNumber = Math.floor(Math.random() * 16) + 1
      }
      return `/static/mp4/${videoNumber}.mp4`
    },
    // 获取屏幕当前显示的点位信息
    getScreenPoint(index) {
      const sourceConfig = this.screenVideoSources.find(s => s.screenIndex === index)
      if (sourceConfig && sourceConfig.pointId) {
        return this.videoPoints.find(p => p.id === sourceConfig.pointId)
      }
      return null
    },
    // 获取筛选后的点位
    getFilteredPoints() {
      return this.videoPoints.filter(point => {
        if (this.filterRegion && point.region !== this.filterRegion) {
          return false
        }
        if (this.filterType && point.type !== this.filterType) {
          return false
        }
        if (this.filterStatus && point.status !== this.filterStatus) {
          return false
        }
        return true
      })
    },
    // 应用筛选并更新地图
    applyFilter() {
      if (!this.map) return

      const filteredPoints = this.getFilteredPoints()

      // 如果有筛选结果，自动缩放到点位区域
      if (filteredPoints.length > 0) {
        this.fitMapToPoints(filteredPoints)
      }

      // 根据当前缩放级别决定显示模式
      const currentZoom = this.map.getZoom()
      if (currentZoom >= 14) {
        // 显示单独点位模式，需要重新创建筛选后的点位
        this.showFilteredIndividualMarkers()
      } else {
        // 显示聚合点模式
        this.showFilteredClusterMarkers()
      }
    },
    // 调整地图视野到点位区域
    fitMapToPoints(points) {
      if (points.length === 0) return

      // 计算所有点位的边界
      let minLat = points[0].lat
      let maxLat = points[0].lat
      let minLng = points[0].lng
      let maxLng = points[0].lng

      points.forEach(point => {
        if (point.lat < minLat) minLat = point.lat
        if (point.lat > maxLat) maxLat = point.lat
        if (point.lng < minLng) minLng = point.lng
        if (point.lng > maxLng) maxLng = point.lng
      })

      // 计算中心点和范围
      const centerLat = (minLat + maxLat) / 2
      const centerLng = (minLng + maxLng) / 2
      const latRange = maxLat - minLat
      const lngRange = maxLng - minLng

      // 计算合适的缩放级别
      const maxRange = Math.max(latRange, lngRange)
      let zoom = 14
      if (maxRange > 0.1) zoom = 10
      else if (maxRange > 0.05) zoom = 11
      else if (maxRange > 0.02) zoom = 12
      else if (maxRange > 0.01) zoom = 13

      // 设置地图中心点和缩放级别
      this.map.setCenter(new TMap.LatLng(centerLat, centerLng))
      this.map.setZoom(zoom)
    },
    // 显示筛选后的单独点位
    showFilteredIndividualMarkers() {
      const filteredPoints = this.getFilteredPoints()
      if (filteredPoints.length === 0) {
        // 如果没有筛选结果，清除所有标记
        if (this.markerLayer && this.markerLayer.setMap) {
          this.markerLayer.setMap(null)
        }
        this.hideTextLabels()
        return
      }

      // 创建图标样式
      const iconStyles = {
        online: new TMap.MarkerStyle({
          width: 20,
          height: 20,
          src: this.statusIcons.online,
          anchor: { x: 10, y: 10 }
        }),
        offline: new TMap.MarkerStyle({
          width: 20,
          height: 20,
          src: this.statusIcons.offline,
          anchor: { x: 10, y: 10 }
        }),
        error: new TMap.MarkerStyle({
          width: 20,
          height: 20,
          src: this.statusIcons.error,
          anchor: { x: 10, y: 10 }
        })
      }

      // 创建标记几何数据
      const geometries = filteredPoints.map(point => ({
        id: point.id.toString(),
        position: new TMap.LatLng(point.lat, point.lng),
        styleId: point.status,
        properties: {
          name: point.name,
          status: point.status,
          url: point.url,
          region: point.region,
          type: point.type
        }
      }))

      // 更新标记层
      if (this.markerLayer && this.markerLayer.setMap) {
        this.markerLayer.setMap(null)
      }
      this.markerLayer = new TMap.MultiMarker({
        map: this.map,
        styles: iconStyles,
        geometries: geometries
      })

      // 添加点击事件
      const that = this
      this.markerLayer.on('click', function (event) {
        let geometry = null
        if (event.detail && event.detail.geometry) {
          geometry = event.detail.geometry
        } else if (event.geometry) {
          geometry = event.geometry
        }

        if (geometry && geometry.properties) {
          const pointId = parseInt(geometry.id)
          that.playVideoFromPoint(pointId, geometry.properties)
        }
      })

      // 显示文字标签
      this.createTextLabels(filteredPoints)
    },
    // 显示筛选后的聚合点
    showFilteredClusterMarkers() {
      const filteredPoints = this.getFilteredPoints()
      if (filteredPoints.length === 0) {
        // 如果没有筛选结果，清除所有标记
        if (this.markerLayer && this.markerLayer.setMap) {
          this.markerLayer.setMap(null)
        }
        this.hideTextLabels()
        return
      }

      // 使用自定义聚合算法
      const clusters = this.clusterPoints(filteredPoints, 0.05)

      // 创建聚合点样式（显示聚合数量）
      const iconStyles = {}
      clusters.forEach((cluster, index) => {
        iconStyles[`cluster_${index}`] = new TMap.MarkerStyle({
          width: 44,
          height: 44,
          anchor: { x: 22, y: 22 },
          src: this.createClusterIcon(cluster.count)
        })
      })

      // 创建聚合点几何数据
      const geometries = clusters.map((cluster, index) => ({
        id: 'cluster_' + index,
        position: new TMap.LatLng(cluster.centerLat, cluster.centerLng),
        styleId: `cluster_${index}`,
        properties: {
          name: `聚合点 (${cluster.count}个)`,
          status: 'online',
          clusterPoints: cluster.points,
          count: cluster.count
        }
      }))

      // 更新标记层
      if (this.markerLayer && this.markerLayer.setMap) {
        this.markerLayer.setMap(null)
      }
      this.markerLayer = new TMap.MultiMarker({
        map: this.map,
        styles: iconStyles,
        geometries: geometries
      })

      // 添加聚合点点击事件
      const that = this
      this.markerLayer.on('click', function (event) {
        let geometry = null
        if (event.detail && event.detail.geometry) {
          geometry = event.detail.geometry
        } else if (event.geometry) {
          geometry = event.geometry
        }

        if (geometry) {
          that.map.setZoom(14)
        }
      })

      // 隐藏文字标签
      this.hideTextLabels()
    },
    // 更新地图标记（旧方法，保留兼容）
    updateMapMarkers(points) {
      if (!this.markerLayer) return

      const markerGeometries = points.map(point => ({
        id: point.id.toString(),
        position: new TMap.LatLng(point.lat, point.lng),
        styleId: point.status,
        properties: {
          name: point.name,
          status: point.status,
          url: point.url,
          region: point.region,
          type: point.type
        }
      }))

      this.markerLayer.setGeometries(markerGeometries)

      // 更新文字标签
      if (this.textLayer) {
        const labelGeometries = points.map(point => ({
          id: 'label_' + point.id.toString(),
          position: new TMap.LatLng(point.lat, point.lng),
          content: point.name,
          styleId: 'label'
        }))
        this.textLayer.setGeometries(labelGeometries)
      }
    },
    // 创建FLV播放器
    createFlvPlayer(videoElement, url, options) {
      if (!videoElement || typeof flvjs === 'undefined') {
        console.error('FLV player creation failed: flvjs not available or video element is null')
        return null
      }
      if (!flvjs.isSupported()) {
        console.error('FLV player creation failed: flvjs is not supported in this browser')
        return null
      }
      var playerOptions = options || {}
      if (playerOptions.muted) {
        videoElement.muted = true
      }
      var player = flvjs.createPlayer({
        type: 'flv',
        url: url,
        isLive: true,
        hasAudio: false,
        hasVideo: true,
        enableStashBuffer: false,
        stashInitialSize: 128,
        lazyLoad: false,
        lazyLoadMaxDuration: 0,
        seekType: 'range',
        cors: true
      })

      // 添加事件监听
      player.on(flvjs.Events.ERROR, (err) => {
        console.error(`FLV player error for ${url}:`, err)
      })
      player.on(flvjs.Events.LOADING_COMPLETE, () => {
        console.log(`FLV player loading complete for ${url}`)
      })
      player.on(flvjs.Events.METADATA_ARRIVED, () => {
        console.log(`FLV player metadata arrived for ${url}`)
      })
      player.on(flvjs.Events.BUFFER_FULL, () => {
        console.log(`FLV player buffer full for ${url}`)
      })

      player.attachMediaElement(videoElement)
      player.load()
      var playPromise = player.play()
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch((err) => {
          console.error(`FLV player play failed for ${url}:`, err)
        })
      }
      return player
    },
    // 初始化视频播放器
    initVideoPlayers() {
      this.destroyVideoPlayers()

      console.log('Initializing video players...')
      console.log('Current screen count:', this.currentScreenCount)

      // 1屏时使用Jessibuca播放器
      if (this.currentScreenCount === 1) {
        this.initSingleScreenJessibucaPlayer()
      } else {
        // 多屏时使用原来的逻辑，直接使用 video 标签的 src 属性播放本地静态视频
        console.log('Using native video src for multi-screen modes')
      }
    },
    // 初始化单屏Jessibuca播放器
    initSingleScreenJessibucaPlayer() {
      console.log('Initializing single screen Jessibuca player...')

      // 先销毁之前的播放器
      this.destroySingleScreenPlayer()

      const container = document.getElementById('singleScreenContainer')
      if (!container) {
        console.error('Single screen container element not found')
        return
      }

      // 检查 Jessibuca 是否已加载
      if (typeof Jessibuca === 'undefined') {
        console.error('Jessibuca is not loaded')
        return
      }

      console.log('Jessibuca is available, creating player instance...')

      // 设置容器样式
      container.style.width = '100%'
      container.style.height = '100%'

      const showOperateBtns = true
      const forceNoOffscreen = true

      try {
        this.singleScreenJessibuca = new Jessibuca({
          container: container,
          hasControl: false,
          videoBuffer: 0.2,
          isResize: false,
          text: "",
          loadingText: "加载中",
          debug: true,
          showBandwidth: false,
          operateBtns: {
            fullscreen: false,
            screenshot: false,
            play: false,
            audio: false,
          },
          forceNoOffscreen: forceNoOffscreen,
          isNotMute: false,
          decoder: "/static/js/decoder.js", // 使用绝对路径
        })

        console.log('Jessibuca player created successfully')

        this.singleScreenJessibuca.onLog = msg => console.error(msg)
        this.singleScreenJessibuca.onRecord = (status) => console.log('onRecord', status)
        this.singleScreenJessibuca.onPause = () => console.log('onPause')
        this.singleScreenJessibuca.onPlay = () => console.log('onPlay')
        this.singleScreenJessibuca.onFullscreen = msg => console.log('onFullscreen', msg)
        this.singleScreenJessibuca.onMute = msg => console.log('onMute', msg)
        this.singleScreenJessibuca.on("log", function (data) {
          console.log('data:', data)
        })

        // 设置默认URL为指定接口
        const defaultUrl = 'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000007.flv'

        console.log('Starting playback with URL:', defaultUrl)

        // 自动播放
        this.singleScreenJessibuca.play(defaultUrl)

        console.log('Play command sent')
      } catch (error) {
        console.error('Error creating or playing Jessibuca player:', error)
        console.error('Error stack:', error.stack)
      }
    },
    // 销毁单屏播放器
    destroySingleScreenPlayer() {
      if (this.singleScreenJessibuca) {
        try {
          this.singleScreenJessibuca.destroy()
        } catch (error) {
          console.error('Failed to destroy single screen Jessibuca player:', error)
        }
        this.singleScreenJessibuca = null
      }
    },
    // 销毁视频播放器
    destroyVideoPlayers() {
      if (!this.videoPlayers.length) {
        return
      }
      this.videoPlayers.forEach(item => {
        const videoElement = this.$refs[item.refName]
        try {
          if (item.player) {
            item.player.pause()
            item.player.unload()
            item.player.detachMediaElement()
            item.player.destroy()
          }
        } catch (error) {
          console.error('Failed to destroy player:', error)
        }
        if (videoElement) {
          try {
            videoElement.pause()
            videoElement.removeAttribute('src')
            videoElement.load()
          } catch (error) {
            console.error('Failed to reset video element:', error)
          }
        }
      })
      this.videoPlayers = []
    },
    // 根据屏数计算网格样式
    getGridStyle() {
      const screenCount = this.currentScreenCount
      let columns = 1
      let gap = 8
      let minWidth = 120

      // 根据屏数确定列数和最小宽度
      if (screenCount === 1) {
        columns = 1
        minWidth = 300
      } else if (screenCount === 4) {
        columns = 2
        minWidth = 140
      } else if (screenCount === 9) {
        columns = 3
        minWidth = 100
      } else if (screenCount === 16) {
        columns = 4
        minWidth = 80
      } else if (screenCount === 64) {
        columns = 8
        minWidth = 50
        gap = 4
      }

      return {
        gridTemplateColumns: `repeat(${columns}, minmax(${minWidth}px, 1fr))`,
        gap: `${gap}px`
      }
    },
    // 切换运维看板面板的展开/隐藏状态
    toggleMaintenancePanel() {
      this.isMaintenancePanelOpen = !this.isMaintenancePanelOpen
    },
    // 打开视频回放弹窗
    openVideoPlayback(event) {
      this.currentEvent = event
      this.isPlaybackModalOpen = true

      // 根据事件类型选择视频
      let videoNumber
      if (event.content === '客流拥堵') {
        // 客流拥堵默认使用第 10 个视频
        videoNumber = 10
      } else {
        // 其他事件随机选择一个本地视频（1.mp4 到 16.mp4）
        videoNumber = Math.floor(Math.random() * 16) + 1
      }
      this.playbackVideoUrl = `/static/mp4/${videoNumber}.mp4`

      // 设置默认导出时间范围
      if (event.startTime && event.endTime) {
        this.exportStartTime = event.startTime.replace(' ', 'T')
        this.exportEndTime = event.endTime.replace(' ', 'T')
      }
    },
    // 关闭视频回放弹窗
    closePlaybackModal() {
      this.isPlaybackModalOpen = false
      this.currentEvent = {}
    },
    // 切换景区展开/收起
    toggleRegion(region) {
      this.expandedRegion = this.expandedRegion === region ? null : region
    },
    // 选择监控点位
    selectPoint(point) {
      if (point.url) {
        // 如果有点位视频URL，切换到该视频
        this.currentPoint = point
        if (this.pointVideoPlayer) {
          this.pointVideoPlayer.destroy()
        }
        this.isPointVideoModalOpen = true
        // 延迟初始化播放器以确保DOM已更新
        setTimeout(() => {
          this.initPointVideoPlayer()
        }, 100)
      }
    },
    // 关闭点位视频播放弹窗
    closePointVideoModal() {
      this.destroyPointVideoPlayer()
      this.isPointVideoModalOpen = false
      // 确保body和文档元素没有被设置pointer-events: none
      document.body.style.pointerEvents = ''
      document.documentElement.style.pointerEvents = ''
    },
    // 销毁点位视频播放器
    destroyPointVideoPlayer() {
      if (this.pointVideoPlayer) {
        try {
          this.pointVideoPlayer.destroy()
          console.log('Point Jessibuca player destroyed successfully')
        } catch (error) {
          console.error('Failed to destroy point video player:', error)
        }
        this.pointVideoPlayer = null
      }
      // 清理容器内残留的canvas等元素，防止阻挡点击事件
      const container = document.getElementById('pointVideoContainer')
      if (container) {
        container.innerHTML = ''
      }
      // 强制移除Jessibuca可能创建的全局遮罩层和canvas
      const allCanvas = document.querySelectorAll('canvas')
      allCanvas.forEach(canvas => {
        // 只移除不在弹窗内的canvas
        if (!canvas.closest('.point-video-modal') && !canvas.closest('.video-playback-modal')) {
          canvas.style.pointerEvents = 'none'
        }
      })
      const jessibucaElements = document.querySelectorAll('[class*="jessibuca"], [id*="jessibuca"], [class*="Jessibuca"]')
      jessibucaElements.forEach(el => {
        if (el.parentNode && !el.closest('.point-video-modal')) {
          el.style.pointerEvents = 'none'
          el.style.display = 'none'
        }
      })
    },
    // 刷新视频流
    refreshVideoStream() {
      if (!this.currentPlayPoint || !this.currentPlayPoint.url) {
        console.log('没有可刷新的视频流')
        return
      }
      // 销毁当前播放器并重新初始化
      this.destroyPointVideoPlayer()
      this.$nextTick(() => {
        this.initPointVideoPlayer(this.currentPlayPoint.url)
      })
    },
    // 导出视频片段
    exportVideo() {
      if (!this.playbackVideoUrl) {
        console.log('没有可导出的视频')
        return
      }

      // 创建隐藏的下载链接
      const link = document.createElement('a')
      link.href = this.playbackVideoUrl
      link.download = `视频片段_${new Date().getTime()}.mp4`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      console.log(`正在下载视频：${this.playbackVideoUrl}`)
    },
    // 获取通道状态样式
    getChannelStatusClass(status) {
      switch (status) {
        case 'normal':
          return 'status-normal'
        case 'abnormal':
          return 'status-abnormal'
        case 'offline':
          return 'status-offline'
        default:
          return 'status-normal'
      }
    },
    // 获取通道状态文字
    getChannelStatusText(status) {
      switch (status) {
        case 'normal':
          return '正常'
        case 'abnormal':
          return '异常'
        case 'offline':
          return '离线'
        default:
          return '未知'
      }
    },
    // 切换实时监控面板的展开/隐藏状态
    togglePanel() {
      console.log('togglePanel called, current state:', this.isPanelExpanded)
      this.isPanelExpanded = !this.isPanelExpanded
      console.log('togglePanel new state:', this.isPanelExpanded)
      // 如果展开，重新初始化视频播放器
      if (this.isPanelExpanded) {
        this.$nextTick(() => {
          this.initVideoPlayers()
        })
      }
    },
    // 开始拖拽（屏幕之间互换）
    startDrag(event, index) {
      // 如果正在从列表拖拽点位到屏幕，不触发屏幕互换拖拽
      if (this.currentScreenCount <= 1 || this.isDraggingPoint) return
      // 排除右键
      if (event.button !== 0) return
      this.dragIndex = index
      event.preventDefault()
      // 使用全局 mousemove 检测拖拽目标（比 mouseenter 更可靠）
      document.addEventListener('mousemove', this._onSwapDragMove)
      document.addEventListener('mouseup', this._onSwapDragEnd)
    },
    // 全局拖拽移动 - 使用 elementFromPoint 检测目标
    _onSwapDragMove(event) {
      if (this.dragIndex === -1) return
      // 临时隐藏 drag-overlay 以确保 elementFromPoint 命中 grid-item
      const el = document.elementFromPoint(event.clientX, event.clientY)
      if (!el) return
      const gridItem = el.closest('.screen-grid-item')
      if (gridItem) {
        // 从兄弟元素中查找索引
        const parent = gridItem.parentElement
        const items = Array.from(parent.children).filter(c => c.classList.contains('screen-grid-item'))
        const idx = items.indexOf(gridItem)
        if (idx !== -1 && idx !== this.dragIndex) {
          this.dragOverIndex = idx
        } else {
          this.dragOverIndex = -1
        }
      } else {
        this.dragOverIndex = -1
      }
    },
    // 全局拖拽结束 - 执行交换
    _onSwapDragEnd() {
      if (this.dragIndex !== -1 && this.dragOverIndex !== -1) {
        this.swapVideoStreams(this.dragIndex, this.dragOverIndex)
      }
      this.dragIndex = -1
      this.dragOverIndex = -1
      document.removeEventListener('mousemove', this._onSwapDragMove)
      document.removeEventListener('mouseup', this._onSwapDragEnd)
    },
    // 点位拖拽相关方法
    startDragPoint(event, point) {
      // 阻止事件冒泡，避免触发屏幕拖拽
      event.stopPropagation()
    },
    onDragPointStart(event, point) {
      console.log('onDragPointStart called:', point)
      if (!point.url) {
        event.preventDefault()
        console.log('Point has no URL, preventing drag')
        return
      }
      this.isDraggingPoint = true
      this.draggingPoint = point
      event.dataTransfer.effectAllowed = 'copy'
      event.dataTransfer.setData('text/plain', JSON.stringify(point))
      console.log('Dragging point set:', this.draggingPoint)
    },
    onDragPointEnd() {
      this.isDraggingPoint = false
      this.draggingPoint = null
      this.dropTargetIndex = -1
    },
    onDropZoneOver(event, index) {
      if (this.isDraggingPoint) {
        this.dropTargetIndex = index
        event.dataTransfer.dropEffect = 'copy'
      }
    },
    onDropZoneLeave() {
      this.dropTargetIndex = -1
    },
    onDropPoint(event, index) {
      console.log('onDropPoint called for index:', index)
      console.log('isDraggingPoint:', this.isDraggingPoint)
      console.log('draggingPoint:', this.draggingPoint)

      event.preventDefault()
      if (this.isDraggingPoint && this.draggingPoint) {
        // 设置该屏幕的视频源为拖拽的点位
        const sourceConfig = {
          screenIndex: index,
          pointId: this.draggingPoint.id,
          url: this.draggingPoint.url
        }

        console.log('Creating sourceConfig:', sourceConfig)
        console.log('Current screenVideoSources before update:', this.screenVideoSources)

        // 使用Vue.set确保响应式更新
        const existingIndex = this.screenVideoSources.findIndex(s => s.screenIndex === index)
        console.log('Existing index found:', existingIndex)

        if (existingIndex >= 0) {
          Vue.set(this.screenVideoSources, existingIndex, sourceConfig)
        } else {
          this.screenVideoSources.push(sourceConfig)
          // 强制触发响应式更新
          this.screenVideoSources = [...this.screenVideoSources]
        }

        console.log('Screen video sources after update:', this.screenVideoSources)
        // 刷新视频
        this.refreshScreenVideo(index)
      }
      this.isDraggingPoint = false
      this.draggingPoint = null
      this.dropTargetIndex = -1
    },
    refreshScreenVideo(index) {
      console.log(`refreshScreenVideo called for index: ${index}`)

      // 在 v-for 中动态 ref 会返回数组，需要正确获取
      const videoRefs = this.$refs['screenVideo' + index]
      const videoElement = Array.isArray(videoRefs) ? videoRefs[0] : videoRefs

      console.log(`Video refs found for index ${index}:`, videoRefs)
      console.log(`Video element for index ${index}:`, videoElement)

      if (!videoElement) {
        console.error('Video element not found for index:', index)
        return
      }

      // 先销毁可能存在的FLV播放器
      this.destroyScreenFlvPlayer(index)

      const url = this.getVideoUrl(index)
      console.log(`Video URL for screen ${index}:`, url)

      // 检查是否是FLV格式
      if (url && url.endsWith('.flv')) {
        // 先暂停并清除原视频，避免冲突
        videoElement.pause()
        videoElement.src = ''

        // 使用FLV播放器
        this.createFlvPlayerForScreen(index, videoElement, url)
      } else {
        // 使用普通视频播放
        videoElement.src = url
        videoElement.load()
        // 加载完成后自动播放
        videoElement.onloadeddata = () => {
          videoElement.play().catch(err => {
            console.error(`Video play failed for screen ${index}:`, err)
          })
        }
      }
    },
    // 为屏幕创建FLV播放器
    createFlvPlayerForScreen(index, videoElement, url) {
      // 先销毁可能存在的播放器
      this.destroyScreenFlvPlayer(index)

      if (!videoElement || typeof flvjs === 'undefined') {
        console.error('FLV player creation failed: flvjs not available or video element is null')
        return
      }

      if (!flvjs.isSupported()) {
        console.error('FLV player creation failed: flvjs is not supported in this browser')
        return
      }

      videoElement.muted = true
      var player = flvjs.createPlayer({
        type: 'flv',
        url: url,
        isLive: true,
        hasAudio: false,
        hasVideo: true,
        enableStashBuffer: false,
        stashInitialSize: 128,
        lazyLoad: false,
        lazyLoadMaxDuration: 0,
        seekType: 'range',
        cors: true
      })

      player.on(flvjs.Events.ERROR, (err) => {
        console.error(`FLV player error for screen ${index}:`, err)
      })

      // 等待加载完成后再播放
      player.on(flvjs.Events.METADATA_ARRIVED, () => {
        console.log(`FLV player metadata arrived for screen ${index}`)
        player.play().catch((err) => {
          console.error(`FLV player play failed after metadata for screen ${index}:`, err)
        })
      })

      player.on(flvjs.Events.LOADING_COMPLETE, () => {
        console.log(`FLV player loading complete for screen ${index}`)
      })

      player.attachMediaElement(videoElement)
      player.load()

      // 保存播放器实例
      if (!this.screenFlvPlayers) {
        this.screenFlvPlayers = {}
      }
      this.screenFlvPlayers[index] = player
    },
    // 销毁屏幕FLV播放器
    destroyScreenFlvPlayer(index) {
      if (this.screenFlvPlayers && this.screenFlvPlayers[index]) {
        try {
          this.screenFlvPlayers[index].destroy()
          delete this.screenFlvPlayers[index]
        } catch (err) {
          console.error('Error destroying FLV player:', err)
        }
      }
    },
    // 销毁所有屏幕FLV播放器
    destroyAllScreenFlvPlayers() {
      if (this.screenFlvPlayers) {
        Object.keys(this.screenFlvPlayers).forEach(index => {
          this.destroyScreenFlvPlayer(parseInt(index))
        })
        this.screenFlvPlayers = {}
      }
    },
    // 恢复之前拖拽设置的视频源
    restoreScreenVideoSources() {
      // 遍历所有已设置的视频源
      this.screenVideoSources.forEach(source => {
        // 只恢复在当前屏幕数量范围内的视频源
        if (source.screenIndex < this.currentScreenCount) {
          this.refreshScreenVideo(source.screenIndex)
        }
      })
    },
    // 交换两个视频流的位置
    swapVideoStreams(fromIndex, toIndex) {
      const onlinePoints = this.videoPoints.filter(p => p.status === 'online')
      if (fromIndex < onlinePoints.length && toIndex < onlinePoints.length) {
        const fromPoint = onlinePoints[fromIndex]
        const toPoint = onlinePoints[toIndex]
        const fromIndexInAll = this.videoPoints.findIndex(p => p.id === fromPoint.id)
        const toIndexInAll = this.videoPoints.findIndex(p => p.id === toPoint.id)
        // 交换位置
        const temp = this.videoPoints[fromIndexInAll]
        this.videoPoints[fromIndexInAll] = this.videoPoints[toIndexInAll]
        this.videoPoints[toIndexInAll] = temp
      }
      // 重新初始化播放器
      this.$nextTick(() => {
        this.destroyVideoPlayers()
        this.initVideoPlayers()
      })
    },
    // 获取网格项样式（根据屏数计算最合适的展示尺寸）
    getGridItemStyle() {
      const screenCount = this.currentScreenCount

      // 外层容器最大为 90vh
      const maxContainerSize = 90

      // 减去标题、底部信息、边距等高度（约 5vh）
      const availableSize = maxContainerSize - 8

      // 根据屏数计算网格行列数
      let cols, rows
      switch (screenCount) {
        case 1:
          cols = 1
          rows = 1
          break
        case 4:
          cols = 2
          rows = 2
          break
        case 9:
          cols = 3
          rows = 3
          break
        case 16:
          cols = 4
          rows = 4
          break
        case 64:
          cols = 8
          rows = 8
          break
        default:
          cols = 1
          rows = 1
      }

      // 计算每个网格项的基础尺寸（考虑 16:9 宽高比）
      // 高度 = availableSize / rows
      // 宽度 = 高度 * (16/9)
      let itemHeight = (availableSize / rows) * 0.95 // 留出 5% 的间距

      // 一屏时使用更小的尺寸
      if (screenCount === 1) {
        itemHeight = itemHeight * 0.6 // 缩小到 60%
      }

      const itemWidth = itemHeight * (16 / 9)

      // 取宽度和高度中的较小值作为最终尺寸（保持正方形，确保不超出容器）
      const finalSize = Math.min(itemWidth, itemHeight)

      return {
        width: `${finalSize}vh`,
        height: `${finalSize * (9 / 16)}vh` // 保持 16:9 比例
      }
    },
    changeScreenCount(count) {
      // 重置拖拽状态
      this.dragIndex = -1
      this.dragOverIndex = -1
      document.removeEventListener('mousemove', this._onSwapDragMove)
      document.removeEventListener('mouseup', this._onSwapDragEnd)

      this.currentScreenCount = count
      this.$nextTick(() => {
        this.initVideoPlayers()
        // 重新应用之前拖拽设置的视频源
        this.restoreScreenVideoSources()
      })
    },
    getToday() {
      const today = new Date()
      const year = today.getFullYear()
      let month = today.getMonth() + 1
      let date = today.getDate()
      let day = today.getDay()
      let hour = today.getHours()
      let minute = today.getMinutes()
      let second = today.getSeconds()

      month = this.doHandleMonth(month)
      date = this.doHandleDate(date)
      hour = this.doHandleHour(hour)
      minute = this.doHandleMinute(minute)
      second = this.doHandleSecond(second)

      this.nowDay = year + '-' + month + '-' + date
      this.nowDay2 = year + '-' + month + '-' + date
      this.nowTime = hour + ':' + minute + ':' + second
      this.week = this.getWeek(day)
    },
    doHandleMonth(month) {
      if (month < 10) {
        return '0' + month
      }
      return month
    },
    doHandleDate(date) {
      if (date < 10) {
        return '0' + date
      }
      return date
    },
    doHandleHour(hour) {
      if (hour < 10) {
        return '0' + hour
      }
      return hour
    },
    doHandleMinute(minute) {
      if (minute < 10) {
        return '0' + minute
      }
      return minute
    },
    doHandleSecond(second) {
      if (second < 10) {
        return '0' + second
      }
      return second
    },
    getWeek(day) {
      const weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      return weekArr[day]
    },
    startClock() {
      this.clockTimer = setInterval(() => {
        const today = new Date()
        let hour = today.getHours()
        let minute = today.getMinutes()
        let second = today.getSeconds()

        hour = this.doHandleHour(hour)
        minute = this.doHandleMinute(minute)
        second = this.doHandleSecond(second)

        this.nowTime = hour + ':' + minute + ':' + second
      }, 1000)
    },
    getSettingById() {
      return getSettingByIdApi({
        scenic_id: this.scenic_id
      }).then(res => {
        if (res.data && res.data.data) {
          this.setting = Object.assign({}, this.setting, res.data.data)
        }
      }).catch(() => {
        return Promise.resolve()
      })
    },
    fetchBoundaryData() {
      const fetchWithFallback = (urls, index = 0) => {
        if (index >= urls.length) {
          return Promise.reject(new Error('All boundary data sources failed'))
        }
        return fetch(urls[index])
          .then(response => {
            if (!response.ok) {
              throw new Error(`Failed to fetch ${urls[index]}`)
            }
            return response.json()
          })
          .catch(() => fetchWithFallback(urls, index + 1))
      }
      return fetchWithFallback(WUYUAN_BOUNDARY_URLS)
    },
    calculateBoundaryBounds() {
      if (!this.boundaryGeometries || this.boundaryGeometries.length === 0) {
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      let minLat = Infinity, maxLat = -Infinity
      let minLng = Infinity, maxLng = -Infinity

      try {
        this.boundaryGeometries.forEach(geo => {
          if (!geo || !geo.coordinates || geo.coordinates.length === 0) {
            return
          }
          const coordinates = geo.coordinates[0]
          if (!coordinates || !Array.isArray(coordinates)) {
            return
          }
          coordinates.forEach(point => {
            if (!point || point.length < 2) {
              return
            }
            const lng = point[0]
            const lat = point[1]
            if (isNaN(lng) || isNaN(lat)) {
              return
            }
            minLng = Math.min(minLng, lng)
            maxLng = Math.max(maxLng, lng)
            minLat = Math.min(minLat, lat)
            maxLat = Math.max(maxLat, lat)
          })
        })
      } catch (error) {
        console.error('Error calculating boundary bounds:', error)
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      if (minLat === Infinity || maxLat === -Infinity || minLng === Infinity || maxLng === -Infinity) {
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      const paddingX = (maxLng - minLng) * WUYUAN_VIEW_HORIZONTAL_PADDING_RATIO
      const paddingY = (maxLat - minLat) * WUYUAN_VIEW_VERTICAL_PADDING_RATIO

      if (paddingX <= 0 || paddingY <= 0) {
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      this.boundaryBounds = {
        sw: { lat: minLat - paddingY, lng: minLng - paddingX },
        ne: { lat: maxLat + paddingY, lng: maxLng + paddingX }
      }

      const centerLat = (minLat + maxLat) / 2
      const centerLng = (minLng + maxLng) / 2
      const viewportWidth = (maxLng - minLng) * (1 + WUYUAN_VIEW_HORIZONTAL_PADDING_RATIO * 2)
      const viewportHeight = (maxLat - minLat) * (1 + WUYUAN_VIEW_VERTICAL_PADDING_RATIO * 2)

      this.viewportBounds = {
        sw: { lat: centerLat - viewportHeight / 2, lng: centerLng - viewportWidth / 2 },
        ne: { lat: centerLat + viewportHeight / 2, lng: centerLng + viewportWidth / 2 }
      }
      return this.boundaryBounds
    },
    renderBoundaryLayer() {
      if (!this.map || !this.boundaryGeometries.length) {
        return
      }

      if (this.boundaryLayer && this.boundaryLayer.setMap) {
        this.boundaryLayer.setMap(null)
      }

      const boundaryStyle = new TMap.PolygonStyle({
        color: 'rgba(24, 50, 112, 0.10)',
        showBorder: true,
        borderColor: 'rgba(120, 238, 255, 0.95)',
        borderWidth: 3
      })

      this.boundaryLayer = new TMap.MultiPolygon({
        map: this.map,
        zIndex: 2,
        styles: {
          boundary: boundaryStyle
        },
        geometries: this.boundaryGeometries
      })
    },
    renderWuyuanHeatMap(retryCount = 0) {
      const maxRetries = 20
      const mapContainer = document.getElementById(this.mapId)

      if (!mapContainer) {
        console.log('Map container not found with id:', this.mapId)
        if (retryCount < maxRetries) {
          requestAnimationFrame(() => {
            this.renderWuyuanHeatMap(retryCount + 1)
          })
        }
        return
      }

      const rect = mapContainer.getBoundingClientRect()
      console.log('Map container rect (attempt', retryCount + 1, '):', rect)

      if (rect.width <= 0 || rect.height <= 0) {
        console.log('Map container size is invalid (width:', rect.width, ', height:', rect.height, '), retrying...')

        const parent = mapContainer.parentElement
        if (parent) {
          const parentRect = parent.getBoundingClientRect()
          console.log('Parent container rect:', parentRect)

          const grandParent = parent.parentElement
          if (grandParent) {
            const grandParentRect = grandParent.getBoundingClientRect()
            console.log('Grand parent container rect:', grandParentRect)
          }
        }

        if (retryCount < maxRetries) {
          setTimeout(() => {
            this.renderWuyuanHeatMap(retryCount + 1)
          }, 100 * (retryCount + 1))
        } else {
          console.error('Failed to initialize map: container size remains invalid after', maxRetries, 'retries')
        }
        return
      }

      console.log('Initializing map with valid container size:', rect.width, 'x', rect.height)

      const warningMapZoom = Math.max(Number(this.setting.map_show || 0), 11)
      const maxZoom = Math.max(warningMapZoom + 4, 15)
      const center = new TMap.LatLng(
        WUYUAN_CENTER.lat + Number(this.setting.lat_offset || 0),
        WUYUAN_CENTER.lng + Number(this.setting.lng_offset || 0)
      )

      if (this.boundaryLayer && this.boundaryLayer.setMap) {
        this.boundaryLayer.setMap(null)
        this.boundaryLayer = null
      }
      if (this.map && this.map.destroy) {
        this.map.destroy()
        this.map = null
      }

      const mapOptions = {
        zoom: warningMapZoom,
        minZoom: 3,
        maxZoom: 20,
        pitch: 0,
        center: center,
        showControl: false,
        baseMap: {
          type: 'vector',
          features: ['base', 'building3d', 'point']
        }
      }

      try {
        this.map = new TMap.Map(this.mapId, mapOptions)
        console.log('Map initialized successfully')

        // 添加地图点击事件，输出经纬度
        this.map.on('click', function (event) {
          const latLng = event.latLng
          console.log('点击位置经纬度:', {
            lat: latLng.getLat().toFixed(6),
            lng: latLng.getLng().toFixed(6)
          })
        })

        this.fetchBoundaryData().then(geoJson => {
          console.log('fetchBoundaryData success:', geoJson)
          if (geoJson && geoJson.features && geoJson.features.length > 0) {
            // 转换 GeoJSON 格式为腾讯地图 MultiPolygon 格式
            this.boundaryGeometries = geoJson.features.map(feature => {
              // GeoJSON 的 coordinates 需要转换为腾讯地图的 paths 格式
              // GeoJSON Polygon: [[[lon, lat], [lon, lat], ...]]
              // 腾讯地图 Polygon: [new TMap.LatLng(lat, lon), new TMap.LatLng(lat, lon), ...]
              const coordinates = feature.geometry.coordinates
              let paths = []

              if (feature.geometry.type === 'Polygon') {
                // Polygon 格式: [[[lon, lat], [lon, lat], ...]]
                paths = coordinates[0].map(coord => new TMap.LatLng(coord[1], coord[0]))
              } else if (feature.geometry.type === 'MultiPolygon') {
                // MultiPolygon 格式: [[[[lon, lat], [lon, lat], ...]], ...]
                paths = coordinates[0][0].map(coord => new TMap.LatLng(coord[1], coord[0]))
              }

              return {
                id: feature.properties.name,
                paths: paths,
                styleId: 'boundary'
              }
            })
            this.calculateBoundaryBounds()
            // 渲染视频点位标记
            this.renderVideoPoints()
          } else {
            console.log('No boundary data, rendering video points directly')
            this.renderVideoPoints()
          }
        }).catch((error) => {
          console.error('fetchBoundaryData failed:', error)
          console.log('Rendering video points without boundary data')
          this.renderVideoPoints()
        })
      } catch (error) {
        console.error('Failed to initialize map:', error)
      }
    },
    renderVideoPoints() {
      console.log('renderVideoPoints called, map:', this.map)
      if (!this.map) {
        console.log('Map is null, returning')
        return
      }

      // 清除旧的标记
      if (this.markerLayer && this.markerLayer.setMap) {
        this.markerLayer.setMap(null)
        this.markerLayer = null
      }

      // 在婺源中心点附近生成视频点位
      const baseLat = WUYUAN_CENTER.lat
      const baseLng = WUYUAN_CENTER.lng
      const offsetRange = 0.05 // 经纬度偏移范围

      // 模拟视频点位数据（实际应从API获取）
      const videoPointsData = [
        // 弦高古城区域
        { id: 101, name: '古城大门', lat: 29.284298, lng: 117.858133, status: 'online', region: '弦高古城', type: '入口', url: 'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000007.flv' },
        { id: 102, name: '老街入口', lat: 29.289184, lng: 117.860625, status: 'online', region: '弦高古城', type: '入口', url: '' },
        { id: 103, name: '古戏台', lat: 29.279493, lng: 117.855593, status: 'online', region: '弦高古城', type: '景点', url: 'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000011.flv' },
        { id: 104, name: '停车场', lat: 29.284337, lng: 117.859875, status: 'offline', region: '弦高古城', type: '停车场', url: '' },
        { id: 105, name: '游客中心', lat: 29.283121, lng: 117.856395, status: 'error', region: '弦高古城', type: '设施', url: '' },
        // 篁岭区域
        { id: 110, name: '篁岭大门', lat: 29.318589, lng: 118.120269, status: 'online', region: '篁岭', type: '入口', url: 'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000007.flv' },
        { id: 111, name: '索道入口', lat: 29.332091, lng: 118.119756, status: 'online', region: '篁岭', type: '入口', url: '' },
        { id: 112, name: '晒秋广场', lat: 29.308457, lng: 118.124857, status: 'online', region: '篁岭', type: '广场', url: 'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000011.flv' },
        { id: 113, name: '观景台', lat: 29.328389, lng: 118.125354, status: 'online', region: '篁岭', type: '景点', url: '' },
        { id: 114, name: '篁岭停车场', lat: 29.322096, lng: 118.109964, status: 'offline', region: '篁岭', type: '停车场', url: '' },
        { id: 115, name: '医务室', lat: 29.308197, lng: 118.122174, status: 'error', region: '篁岭', type: '设施', url: '' },
        // 卧龙谷区域
        { id: 120, name: '景区大门', lat: 29.265432, lng: 117.789456, status: 'online', region: '卧龙谷', type: '入口', url: 'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000007.flv' },
        { id: 121, name: '瀑布观景台', lat: 29.270123, lng: 117.793456, status: 'online', region: '卧龙谷', type: '景点', url: '' },
        { id: 122, name: '卧龙谭', lat: 29.271234, lng: 117.794567, status: 'online', region: '卧龙谷', type: '景点', url: 'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000011.flv' },
        { id: 123, name: '停车场', lat: 29.264567, lng: 117.788765, status: 'offline', region: '卧龙谷', type: '停车场', url: '' },
        // 婺女州区域
        { id: 130, name: '度假区大门', lat: 29.295678, lng: 117.845123, status: 'online', region: '婺女州', type: '入口', url: 'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000007.flv' },
        { id: 131, name: '婺女广场', lat: 29.301234, lng: 117.850678, status: 'online', region: '婺女州', type: '广场', url: '' },
        { id: 132, name: '温泉区', lat: 29.303456, lng: 117.852890, status: 'online', region: '婺女州', type: '景点', url: 'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000011.flv' },
        { id: 133, name: '度假区停车场', lat: 29.294567, lng: 117.844567, status: 'online', region: '婺女州', type: '停车场', url: '' },
        { id: 134, name: '水上乐园', lat: 29.302345, lng: 117.851789, status: 'error', region: '婺女州', type: '景点', url: '' },
        // 月亮湾区域
        { id: 79, name: '游客中心', lat: 29.305486, lng: 117.885144, status: 'online', region: '月亮湾', type: '设施', url: 'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000007.flv' },
        { id: 80, name: '出口', lat: 29.305261, lng: 117.885745, status: 'online', region: '月亮湾', type: '出口', url: '' },
        { id: 81, name: '游客栈道', lat: 29.304214, lng: 117.886131, status: 'online', region: '月亮湾', type: '道路', url: 'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000011.flv' },
        { id: 82, name: '观景台', lat: 29.303091, lng: 117.886517, status: 'online', region: '月亮湾', type: '景点', url: 'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000007.flv' },
        { id: 83, name: '竹筏售票口', lat: 29.301781, lng: 117.886646, status: 'online', region: '月亮湾', type: '商业', url: 'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000011.flv' },
        { id: 84, name: '观景台', lat: 29.299948, lng: 117.885187, status: 'online', region: '月亮湾', type: '景点', url: 'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000007.flv' },
        { id: 85, name: '停车场', lat: 29.304800, lng: 117.884500, status: 'offline', region: '月亮湾', type: '停车场', url: '' },
        { id: 86, name: '洗手间', lat: 29.302500, lng: 117.886000, status: 'error', region: '月亮湾', type: '设施', url: '' }
      ]

      this.videoPoints = videoPointsData

      // 创建图标样式
      const iconStyles = {
        online: new TMap.MarkerStyle({
          width: 20,
          height: 20,
          src: this.statusIcons.online,
          anchor: { x: 10, y: 10 }
        }),
        offline: new TMap.MarkerStyle({
          width: 20,
          height: 20,
          src: this.statusIcons.offline,
          anchor: { x: 10, y: 10 }
        }),
        error: new TMap.MarkerStyle({
          width: 20,
          height: 20,
          src: this.statusIcons.error,
          anchor: { x: 10, y: 10 }
        })
      }

      // 创建标记几何数据
      const geometries = videoPointsData.map(point => {
        return {
          id: point.id.toString(),
          position: new TMap.LatLng(point.lat, point.lng),
          styleId: point.status,
          properties: {
            name: point.name,
            status: point.status,
            url: point.url,
            region: point.region,
            type: point.type
          }
        }
      })

      // 创建标记层
      this.createMarkerLayer(videoPointsData, geometries, iconStyles)

      // 创建文字标签（根据初始缩放级别决定是否显示）
      if (this.map.getZoom() >= 14) {
        this.createTextLabels(videoPointsData)
      }

      // 添加缩放级别监听，实现聚合功能
      const that = this
      this.map.on('zoomend', function () {
        const currentZoom = that.map.getZoom()
        console.log('Map zoom changed to:', currentZoom)
        that.handleZoomChange(currentZoom)
      })

      // 初始化时根据当前缩放级别设置显示模式
      this.handleZoomChange(this.map.getZoom())
    },
    // 根据缩放级别处理聚合/单独显示
    handleZoomChange(zoom) {
      if (!this.map || !this.videoPoints || this.videoPoints.length === 0) {
        return
      }

      if (zoom >= 14) {
        // 缩放级别 >= 14，显示单独点位
        this.showIndividualMarkers()
      } else {
        // 缩放级别 < 14，显示聚合点
        this.showClusterMarkers()
      }
    },
    // 显示单独点位
    showIndividualMarkers() {
      if (!this.map || !this.videoPoints || this.videoPoints.length === 0) {
        return
      }

      // 创建图标样式
      const iconStyles = {
        online: new TMap.MarkerStyle({
          width: 20,
          height: 20,
          src: this.statusIcons.online,
          anchor: { x: 10, y: 10 }
        }),
        offline: new TMap.MarkerStyle({
          width: 20,
          height: 20,
          src: this.statusIcons.offline,
          anchor: { x: 10, y: 10 }
        }),
        error: new TMap.MarkerStyle({
          width: 20,
          height: 20,
          src: this.statusIcons.error,
          anchor: { x: 10, y: 10 }
        })
      }

      // 创建标记几何数据
      const geometries = this.videoPoints.map(point => ({
        id: point.id.toString(),
        position: new TMap.LatLng(point.lat, point.lng),
        styleId: point.status,
        properties: {
          name: point.name,
          status: point.status,
          url: point.url,
          region: point.region,
          type: point.type
        }
      }))

      // 更新标记层
      if (this.markerLayer && this.markerLayer.setMap) {
        this.markerLayer.setMap(null)
      }
      this.markerLayer = new TMap.MultiMarker({
        map: this.map,
        styles: iconStyles,
        geometries: geometries
      })

      // 添加点击事件
      const that = this
      this.markerLayer.on('click', function (event) {
        let geometry = null
        if (event.detail && event.detail.geometry) {
          geometry = event.detail.geometry
        } else if (event.geometry) {
          geometry = event.geometry
        }

        if (geometry && geometry.properties) {
          const pointId = parseInt(geometry.id)
          that.playVideoFromPoint(pointId, geometry.properties)
        }
      })

      // 显示文字标签
      this.createTextLabels(this.videoPoints)
    },
    // 显示聚合点
    showClusterMarkers() {
      if (!this.map || !this.videoPoints || this.videoPoints.length === 0) {
        return
      }

      // 使用自定义聚合算法
      const clusters = this.clusterPoints(this.videoPoints, 0.05)

      // 创建聚合点样式（显示聚合数量）
      const iconStyles = {}
      clusters.forEach((cluster, index) => {
        iconStyles[`cluster_${index}`] = new TMap.MarkerStyle({
          width: 40,
          height: 40,
          anchor: { x: 20, y: 20 },
          src: this.createClusterIcon(cluster.count)
        })
      })

      // 创建聚合点几何数据
      const geometries = clusters.map((cluster, index) => ({
        id: 'cluster_' + index,
        position: new TMap.LatLng(cluster.centerLat, cluster.centerLng),
        styleId: `cluster_${index}`,
        properties: {
          name: `聚合点 (${cluster.count}个)`,
          status: 'online',
          clusterPoints: cluster.points,
          count: cluster.count
        }
      }))

      // 更新标记层
      if (this.markerLayer && this.markerLayer.setMap) {
        this.markerLayer.setMap(null)
      }
      this.markerLayer = new TMap.MultiMarker({
        map: this.map,
        styles: iconStyles,
        geometries: geometries
      })

      // 添加聚合点点击事件，点击后自动缩放到显示单独点位的层级
      const that = this
      this.markerLayer.on('click', function (event) {
        let geometry = null
        if (event.detail && event.detail.geometry) {
          geometry = event.detail.geometry
        } else if (event.geometry) {
          geometry = event.geometry
        }

        if (geometry) {
          // 点击聚合点时，缩放到级别14（显示单独点位的层级）
          that.map.setZoom(14)
        }
      })

      // 隐藏文字标签（图标上已显示数量，不需要额外标签）
      this.hideTextLabels()
    },
    // 创建科技感聚合点图标（带数字）
    createClusterIcon(count) {
      // 使用canvas绘制并转换为base64图片
      const canvas = document.createElement('canvas')
      canvas.width = 44
      canvas.height = 44
      const ctx = canvas.getContext('2d')

      // 绘制六边形路径
      const drawHexagon = (cx, cy, r) => {
        ctx.beginPath()
        for (let i = 0; i < 6; i++) {
          const angle = (Math.PI / 3) * i - Math.PI / 2
          const x = cx + r * Math.cos(angle)
          const y = cy + r * Math.sin(angle)
          if (i === 0) {
            ctx.moveTo(x, y)
          } else {
            ctx.lineTo(x, y)
          }
        }
        ctx.closePath()
      }

      // 外层光晕 - 淡粉色六边形
      const gradient1 = ctx.createRadialGradient(22, 22, 0, 22, 22, 22)
      gradient1.addColorStop(0, 'rgba(255, 182, 193, 0.5)')
      gradient1.addColorStop(1, 'rgba(255, 182, 193, 0)')
      drawHexagon(22, 22, 22)
      ctx.fillStyle = gradient1
      ctx.fill()

      // 主六边形 - 淡粉色渐变
      const gradient2 = ctx.createRadialGradient(18, 18, 0, 22, 22, 15)
      gradient2.addColorStop(0, '#ffc0cb')
      gradient2.addColorStop(1, '#ff69b4')
      drawHexagon(22, 22, 15)
      ctx.fillStyle = gradient2
      ctx.fill()
      ctx.strokeStyle = '#ffb6c1'
      ctx.lineWidth = 2
      ctx.stroke()

      // 内六边形装饰
      drawHexagon(22, 22, 10)
      ctx.strokeStyle = 'rgba(255, 182, 193, 0.7)'
      ctx.lineWidth = 1.5
      ctx.stroke()

      // 数字
      ctx.fillStyle = '#ffffff'
      ctx.font = 'bold 14px Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText(count, 22, 22)

      return canvas.toDataURL('image/png')
    },
    // 隐藏文字标签
    hideTextLabels() {
      if (this.textLayer && this.textLayer.setMap) {
        this.textLayer.setMap(null)
        this.textLayer = null
      }
    },
    // 自定义点位聚合算法
    clusterPoints(points, threshold) {
      const clusters = []
      const visited = new Set()

      for (let i = 0; i < points.length; i++) {
        if (visited.has(i)) continue

        const cluster = {
          centerLat: points[i].lat,
          centerLng: points[i].lng,
          count: 1,
          points: [points[i]]
        }
        visited.add(i)

        for (let j = i + 1; j < points.length; j++) {
          if (visited.has(j)) continue

          const distance = this.calculateDistance(points[i].lat, points[i].lng, points[j].lat, points[j].lng)
          if (distance < threshold) {
            cluster.centerLat = (cluster.centerLat * cluster.count + points[j].lat) / (cluster.count + 1)
            cluster.centerLng = (cluster.centerLng * cluster.count + points[j].lng) / (cluster.count + 1)
            cluster.count++
            cluster.points.push(points[j])
            visited.add(j)
          }
        }

        clusters.push(cluster)
      }

      return clusters
    },
    // 计算两点之间的距离
    calculateDistance(lat1, lng1, lat2, lng2) {
      const latDiff = Math.abs(lat1 - lat2)
      const lngDiff = Math.abs(lng1 - lng2)
      return Math.sqrt(latDiff * latDiff + lngDiff * lngDiff)
    },
    // 创建标记层（初始化时使用）
    createMarkerLayer(pointsData, geometries, iconStyles) {
      // 清除旧的标记
      if (this.markerLayer && this.markerLayer.setMap) {
        this.markerLayer.setMap(null)
        this.markerLayer = null
      }

      // 创建普通标记层
      this.markerLayer = new TMap.MultiMarker({
        map: this.map,
        styles: iconStyles,
        geometries: geometries
      })

      // 添加点击事件
      const that = this
      this.markerLayer.on('click', function (event) {
        let geometry = null
        if (event.detail && event.detail.geometry) {
          geometry = event.detail.geometry
        } else if (event.geometry) {
          geometry = event.geometry
        }

        if (geometry && geometry.properties) {
          const pointId = parseInt(geometry.id)
          that.playVideoFromPoint(pointId, geometry.properties)
        }
      })
    },
    // 创建文本标注
    createTextLabels(pointsData) {
      // 如果已存在标注层，先销毁
      if (this.textLayer) {
        this.textLayer.setMap(null)
        this.textLayer = null
      }

      const statusColors = {
        online: '#52c41a',
        offline: '#8c8c8c',
        error: '#ff4d4f'
      }

      const textGeometries = []
      pointsData.forEach(point => {
        // 只显示名称标签，状态通过图标颜色区分
        textGeometries.push({
          id: 'name_' + point.id,
          position: new TMap.LatLng(point.lat, point.lng),
          styleId: 'nameStyle',
          content: point.name
        })
      })

      this.textLayer = new TMap.MultiLabel({
        map: this.map,
        styles: {
          nameStyle: new TMap.LabelStyle({
            fontSize: 12,
            color: '#2c3e50',
            fontWeight: 'bold',
            offset: { x: 0, y: 22 },
            whiteSpace: 'nowrap',
            strokeColor: 'rgba(255, 255, 255, 0.9)',
            strokeWidth: 4,
            fontFamily: 'Microsoft YaHei, SimHei, sans-serif'
          })
        },
        geometries: textGeometries
      })
    },
    // 从点位播放视频
    playVideoFromPoint(pointId, properties) {
      const statusMap = {
        online: '在线',
        offline: '已离线',
        error: '异常'
      }

      // 设置当前播放的点位信息
      this.currentPlayPoint = {
        id: pointId,
        name: properties.name,
        status: properties.status,
        region: properties.region,
        type: properties.type,
        statusText: statusMap[properties.status] || '未知'
      }

      // 如果是在线状态，使用该点位自己的视频流 URL，如果没有则从 videoPoints 中选择一个
      if (properties.status === 'online') {
        if (properties.url) {
          this.currentPlayPoint.url = properties.url
        } else {
          // 获取所有在线点位的视频流 URL
          const onlinePoints = this.videoPoints.filter(p => p.status === 'online' && p.url)
          if (onlinePoints.length > 0) {
            // 随机选择一个视频流
            const randomIndex = Math.floor(Math.random() * onlinePoints.length)
            this.currentPlayPoint.url = onlinePoints[randomIndex].url
          }
        }
      }

      // 打开视频播放弹窗
      this.isPointVideoModalOpen = true

      // 在弹窗打开后初始化播放器
      this.$nextTick(() => {
        if (this.currentPlayPoint.status === 'online' && this.currentPlayPoint.url) {
          this.initPointVideoPlayer(this.currentPlayPoint.url)
        }
      })

      console.log(`正在播放：${properties.name}`)
    },
    // 初始化点位视频播放器
    initPointVideoPlayer(url) {
      console.log('Initializing point video player with URL:', url)

      // 先销毁之前的播放器
      this.destroyPointVideoPlayer()

      // 检查 Jessibuca 是否已加载
      if (typeof Jessibuca === 'undefined') {
        console.error('Jessibuca is not loaded')
        return
      }

      const container = document.getElementById('pointVideoContainer')
      if (!container) {
        console.error('Point video container element not found')
        return
      }

      // 设置容器样式
      container.style.width = '100%'
      container.style.height = '100%'

      try {
        this.pointVideoPlayer = new Jessibuca({
          container: container,
          hasControl: false,
          videoBuffer: 0.2,
          isResize: false,
          text: "",
          loadingText: "加载中",
          debug: true,
          showBandwidth: false,
          operateBtns: {
            fullscreen: false,
            screenshot: false,
            play: false,
            audio: false,
          },
          forceNoOffscreen: true,
          isNotMute: false,
          decoder: "/static/js/decoder.js",
        })

        console.log('Point Jessibuca player created successfully')

        this.pointVideoPlayer.onLog = msg => console.error(msg)
        this.pointVideoPlayer.onRecord = (status) => console.log('onRecord', status)
        this.pointVideoPlayer.onPause = () => console.log('onPause')
        this.pointVideoPlayer.onPlay = () => console.log('onPlay')
        this.pointVideoPlayer.onFullscreen = msg => console.log('onFullscreen', msg)
        this.pointVideoPlayer.onMute = msg => console.log('onMute', msg)
        this.pointVideoPlayer.on("log", function (data) {
          console.log('data:', data)
        })

        // 如果没有传入URL，从videoPoints中随机选择一个
        let playUrl = url
        if (!playUrl || playUrl.trim() === '') {
          if (this.videoPoints.length > 0) {
            playUrl = this.videoPoints[Math.floor(Math.random() * this.videoPoints.length)]
            console.log('No URL provided, using random video from videoPoints:', playUrl)
          } else {
            playUrl = 'https://hunou-vod.q12301.com/video/0402b05801a09731/0000000011.flv'
            console.log('No URL provided and no videoPoints available, using default URL:', playUrl)
          }
        }

        console.log('Starting playback with URL:', playUrl)

        // 自动播放
        this.pointVideoPlayer.play(playUrl)

        console.log('Play command sent')
      } catch (error) {
        console.error('Error creating or playing point video Jessibuca player:', error)
        console.error('Error stack:', error.stack)
      }
    },
    changeTheDate(day) {
      if (day === 0) {
        const query = {
          id: this.scenic_id,
          token: store.state.token
        }
        this.$router.push({ path: '/scenic_warning', query: query })
        this.$router.go(0)
        return
      }

      const today = this.req_date ? new Date(this.req_date) : new Date()
      const targetdayMilliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
      today.setTime(targetdayMilliseconds)
      const tYear = today.getFullYear()
      let tMonth = today.getMonth()
      let tDate = today.getDate()
      tMonth = this.doHandleMonth(tMonth + 1)
      tDate = this.doHandleDate(tDate)
      const changeDate = tYear + '-' + tMonth + '-' + tDate
      const query = {
        id: this.scenic_id,
        date: changeDate,
        token: store.state.token
      }
      this.$router.push({ path: '/scenic_warning', query: query })
      this.$router.go(0)
    }
  }
}
</script>

<style scoped>
.page-container {
  width: 100vw;
  height: calc(100vh - 54px);
  font-family: PingFang SC;
  user-select: none;
}

.data-box {
  background-color: rgba(3, 10, 69, 0.92);
  box-shadow: -1px -1px 10px 2px rgba(78, 240, 228, 0.1);
  background-image: url(../../static/img/border-top.png), url(../../static/img/border-bottom.png);
  background-repeat: no-repeat, no-repeat;
  background-position: -0.3% -0.3%, 100.3% 100.3%;
  border: 1px solid rgba(80, 220, 255, 0.28);
}

.head {
  position: relative;
  height: 80px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
}

.head-title {
  display: inline-block;
  font-size: 16px;
  vertical-align: middle;
}

.head-logo {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  transform: translate(0, -2px);
}

.head-type {
  width: 520px;
  max-width: 100%;
  height: 54px;
  display: flex;
  justify-content: space-around;
  vertical-align: middle;
}

.type-item {
  position: relative;
  height: 100%;
  display: inline-block;
  color: #575785;
  cursor: pointer;
}

.type-item2 {
  color: #606266;
}

.type-on {
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #023AFF;
  border-radius: 1px;
}

.date-weather {
  display: inline-block;
  padding: 0 15px;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  color: #606266;
}

.warning-main {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 500px;
  background: rgba(6, 14, 96, 0.6);
  overflow: hidden;
}

.migrateMap {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  min-width: 500px;
  min-height: 500px;
  background-color: #0a1628;
  z-index: 0;
}

/* 监控点位统计 */
.video-points-stats {
  display: flex;
  justify-content: space-around;
  gap: 12px;
  padding: 12px 16px;
  margin-bottom: 16px;
  background: rgba(3, 10, 69, 0.8);
  border-radius: 6px;
  border: 1px solid rgba(80, 220, 255, 0.2);
}

.stats-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.stats-icon {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}

.online-icon {
  background: #52c41a;
  box-shadow: 0 0 8px rgba(82, 196, 26, 0.6);
}

.offline-icon {
  background: #8c8c8c;
  box-shadow: 0 0 8px rgba(140, 140, 140, 0.6);
}

.error-icon {
  background: #ff4d4f;
  box-shadow: 0 0 8px rgba(255, 77, 79, 0.6);
}

.total-icon {
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  box-shadow: 0 0 8px rgba(76, 217, 255, 0.6);
}

.stats-label {
  font-size: 12px;
  color: rgba(96, 98, 102, 0.7);
  white-space: nowrap;
}

.stats-count {
  font-size: 16px;
  font-weight: 700;
  color: #606266;
  text-align: center;
  min-width: 28px;
}

/* 视频监控 */
.video-stream-section {
  margin-top: 16px;
  padding: 12px;
  background: rgba(3, 10, 69, 0.92);
  border-radius: 8px;
  border: 1px solid rgba(80, 220, 255, 0.28);
}

.video-stream-list {
  margin-top: 10px;
}

.video-stream-item {
  margin-bottom: 16px;
}

.video-stream-item:last-child {
  margin-bottom: 0;
}

.stream-title {
  padding: 8px 10px;
  color: #606266;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}

.stream-body {
  padding: 0 10px 10px;
  box-sizing: border-box;
  width: 100%;
}

.stream-video {
  display: block;
  width: 100%;
  height: 200px;
  max-width: 100%;
  max-height: 100%;
  box-sizing: border-box;
  object-fit: contain;
  background-color: #000;
  border-radius: 4px;
}

.warning-left {
  float: left;
  margin: 16px 16px 0 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
  height: calc(100% - 32px);
}

.warning-right {
  position: fixed;
  right: 16px;
  top: 96px;
  z-index: 29;
  max-width: 90vh;
  max-height: 90vh;
}

.warning-right.collapsed {
  max-width: 200px;
  max-height: 40px;
}

.monitor-toggle-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  color: #000;
}

.monitor-toggle-header:hover {
  background: rgba(255, 255, 255, 0.05);
}

.monitor-toggle-header .monitor-title {
  font-size: 16px;
  font-weight: 700;
  color: #000;
  margin-bottom: 0;
}

.toggle-icon {
  font-size: 12px;
  color: #4cd9ff;
}

.monitor-content {
  margin-top: 0;
  padding: 0;
  overflow: hidden;
  max-height: 0;
  opacity: 0;
}

.monitor-content.show {
  margin-top: 8px;
  max-height: 60vh;
  opacity: 1;
}

/* 拖拽视觉反馈 - 白底主题 */
.screen-grid-item {
  cursor: grab;
  position: relative;
  transition: box-shadow 0.25s ease, border-color 0.25s ease, transform 0.2s ease;
}

.screen-grid-item:hover {
  border-color: #93c5fd;
  z-index: 2;
}

.screen-grid-item:hover .drag-overlay {
  opacity: 1;
}

/* 拖拽源：缩小 + 虚线边框 + 淡化 */
.screen-grid-item.is-dragging {
  cursor: grabbing;
  opacity: 0.35;
  border-color: #93c5fd;
  transform: scale(0.97);
}

.screen-grid-item.is-dragging .drag-overlay {
  opacity: 0;
}

/* 拖拽经过目标：蓝色脉冲边框 + 覆盖层 */
.screen-grid-item.is-drag-over {
  border: 2px solid #3b82f6;
  box-shadow: 0 0 8px rgba(59, 130, 246, 0.25);
  z-index: 3;
}

.screen-grid-item.is-drag-over .drag-overlay {
  opacity: 1;
  background: rgba(59, 130, 246, 0.15);
}

.screen-grid-item.is-drag-over .drag-overlay-icon {
  border-color: #3b82f6;
  color: #3b82f6;
  background: rgba(255, 255, 255, 0.95);
}

/* 点位拖放目标：绿色脉冲边框 */
.screen-grid-item.is-drop-target {
  border: 2px solid #10b981;
  box-shadow: 0 0 8px rgba(16, 185, 129, 0.25);
  z-index: 3;
}

.screen-grid-item.is-drop-target .drag-overlay {
  opacity: 1;
  background: rgba(16, 185, 129, 0.12);
}

.screen-grid-item.is-drop-target .drag-overlay-icon {
  border-color: #10b981;
  color: #10b981;
  background: rgba(255, 255, 255, 0.95);
}

/* 拖拽覆盖层 */
.drag-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease, background 0.2s ease;
  pointer-events: none;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
}

.drag-overlay-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 14px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.9);
  border: 1.5px solid #d1d5db;
  color: #6b7280;
  backdrop-filter: blur(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.drag-label-text {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

/* 运维看板按钮 */
.maintenance-section {
  margin-top: 16px;
}

.maintenance-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  background: rgba(76, 217, 255, 0.1);
  border: 1px solid rgba(80, 220, 255, 0.3);
  border-radius: 4px;
  color: #4cd9ff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.maintenance-btn:hover {
  background: rgba(76, 217, 255, 0.2);
  border-color: rgba(80, 220, 255, 0.5);
}

.maintenance-btn.active {
  background: rgba(76, 217, 255, 0.25);
  border-color: #4cd9ff;
}

.maintenance-icon {
  font-size: 16px;
}

.maintenance-badge {
  background: #ff4d4f;
  color: #606266;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
}

/* 数据传输通道状态 - 列表样式 */
.channel-status-list {
  max-height: 180px;
  overflow-y: auto;
}

.channel-info-content {
  flex: 1;
  min-width: 0;
  margin-right: 12px;
}

.channel-device-text {
  font-size: 11px;
  color: rgba(96, 98, 102, 0.6);
  margin-top: 4px;
}

.channel-status-badge {
  padding: 4px 10px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  margin-right: 12px;
  background: rgba(103, 194, 58, 0.2);
  color: #67c23a;
  white-space: nowrap;
}

.channel-status-badge.status-normal {
  background: rgba(103, 194, 58, 0.2);
  color: #67c23a;
}

.channel-status-badge.status-abnormal {
  background: rgba(255, 165, 2, 0.2);
  color: #ffa502;
}

.channel-status-badge.status-offline {
  background: rgba(96, 98, 102, 0.2);
  color: rgba(96, 98, 102, 0.7);
}

.channel-time-text {
  font-size: 11px;
  color: rgba(96, 98, 102, 0.5);
  white-space: nowrap;
}

/* 运维看板面板 */
.maintenance-panel {
  position: absolute;
  left: 430px;
  top: 16px;
  width: 380px;
  height: calc(100% - 32px);
  z-index: 150;
  opacity: 0;
  visibility: hidden;
  transform: translateX(-20px);
  transition: all 0.3s ease-out;
}

.maintenance-panel.show {
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
}

.maintenance-content {
  height: 100%;
  max-height: calc(100vh - 32px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.maintenance-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(80, 220, 255, 0.2);
}

.maintenance-title {
  font-size: 16px;
  font-weight: 700;
  color: #606266;
}

.maintenance-close {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #8cefff;
  font-size: 20px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s;
}

.maintenance-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* 通道列表 */
.channel-list {
  padding: 8px;
  overflow-y: auto;
  max-height: calc(70vh - 60px);
}

.channel-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  margin-bottom: 6px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 4px;
  border-left: 3px solid transparent;
  transition: all 0.2s ease;
}

.channel-item.status-normal {
  border-left-color: #52c41a;
}

.channel-item.status-abnormal {
  border-left-color: #ff4d4f;
  background: rgba(255, 77, 79, 0.08);
  animation: pulse-abnormal 2s infinite;
}

.channel-item.status-offline {
  border-left-color: #d9d9d9;
  opacity: 0.7;
}

@keyframes pulse-abnormal {

  0%,
  100% {
    background: rgba(255, 77, 79, 0.08);
  }

  50% {
    background: rgba(255, 77, 79, 0.15);
  }
}

.channel-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
}

.channel-item.status-normal .channel-status-dot {
  background: #52c41a;
  box-shadow: 0 0 6px #52c41a;
}

.channel-item.status-abnormal .channel-status-dot {
  background: #ff4d4f;
  box-shadow: 0 0 6px #ff4d4f;
  animation: blink 1s infinite;
}

.channel-item.status-offline .channel-status-dot {
  background: #d9d9d9;
}

@keyframes blink {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }
}

.channel-info {
  flex: 1;
  min-width: 0;
}

.channel-name {
  font-size: 13px;
  font-weight: 500;
  color: #606266;
  margin-bottom: 2px;
}

.channel-device {
  font-size: 11px;
  color: #8cefff;
}

.channel-status {
  margin: 0 10px;
}

.channel-status span {
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
}

.channel-status .status-normal {
  background: rgba(82, 196, 26, 0.15);
  color: #52c41a;
}

.channel-status .status-abnormal {
  background: rgba(255, 77, 79, 0.15);
  color: #ff4d4f;
}

.channel-status .status-offline {
  background: rgba(217, 217, 217, 0.15);
  color: #d9d9d9;
}

.channel-time {
  text-align: right;
}

.time-label {
  font-size: 11px;
  color: #888;
}

.time-value {
  display: block;
  font-size: 11px;
  color: #000;
  margin-top: 2px;
}

.warning-panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 20px 18px 16px;
  box-sizing: border-box;
  overflow: hidden;
}

.warning-panel-large {
  height: calc(100% - 250px);
  min-height: 640px;
}

.warning-panel-small {
  margin-top: 14px;
  height: 236px;
}

.sentiment-panel {
  flex: 1;
  min-height: 0;
  margin-bottom: 14px;
}

.sentiment-panel:last-child {
  margin-bottom: 0;
}

.sentiment-chart {
  width: 100%;
  height: calc(100% - 30px);
  min-height: 120px;
}

.sentiment-keywords {
  margin-top: 12px;
}

.sentiment-keywords-title {
  font-size: 12px;
  color: #8cefff;
  margin-bottom: 10px;
  font-weight: 600;
}

.sentiment-keywords-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.sentiment-keyword-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background: rgba(45, 72, 180, 0.35);
  border-radius: 4px;
}

.keyword-label {
  font-size: 12px;
  color: rgba(96, 98, 102, 0.86);
}

.keyword-count {
  font-size: 12px;
  color: #606266;
  font-weight: 600;
}

.keyword-panel-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.keyword-edit-btn {
  background: linear-gradient(135deg, #6fb8ff 0%, #00d4aa 100%);
  border: none;
  color: #141439;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 16px;
  border-radius: 12px;
  cursor: pointer;
}

.keyword-table-container {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin-top: 12px;
  padding-right: 4px;
}

.keyword-table-container::-webkit-scrollbar {
  width: 4px;
}

.keyword-table-container::-webkit-scrollbar-track {
  background: transparent;
}

.keyword-table-container::-webkit-scrollbar-thumb {
  background: rgba(85, 137, 242, 0.5);
  border-radius: 2px;
}

.keyword-table {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.keyword-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 10px;
  background: rgba(45, 72, 180, 0.35);
  border-radius: 4px;
  position: relative;
}

.keyword-row.keyword-disabled {
  opacity: 0.5;
}

.keyword-tag {
  font-size: 12px;
  color: #8cefff;
  margin-bottom: 4px;
}

.keyword-value {
  font-size: 14px;
  color: #606266;
  font-weight: 600;
}

.keyword-switch {
  position: absolute;
  top: 4px;
  right: 4px;
  cursor: pointer;
}

.switch-track {
  display: inline-block;
  width: 28px;
  height: 16px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  position: relative;
  transition: background 0.3s;
  cursor: pointer;
}

.switch-track.switch-on {
  background: #4cd9ff;
}

.switch-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 50%;
  transition: left 0.3s;
}

.switch-thumb.switch-thumb-on {
  left: 14px;
}



.warning-panel-title {
  font-size: 18px;
  font-weight: 700;
  color: #606266;
  margin-bottom: 18px;
}

.warning-right .warning-panel-title {
  margin-bottom: 12px;
  flex-shrink: 0;
}

.warning-panel-full {
  height: calc(100% - 20px);
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.supervision-warning-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
}

.supervision-warning-list::-webkit-scrollbar {
  width: 4px;
}

.supervision-warning-list::-webkit-scrollbar-track {
  background: transparent;
}

.supervision-warning-list::-webkit-scrollbar-thumb {
  background: rgba(85, 137, 242, 0.5);
  border-radius: 2px;
}

.supervision-warning-item {
  padding: 12px;
  margin-bottom: 10px;
  background: rgba(45, 72, 180, 0.35);
  border-radius: 6px;
  border-left: 3px solid #5589F2;
}

.supervision-warning-item.negative-warning {
  border-left: 3px solid #E53F31;
  background: rgba(229, 63, 49, 0.15);
}

.supervision-warning-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.warning-id {
  font-size: 11px;
  color: rgba(96, 98, 102, 0.5);
}

.warning-status {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 600;
}

.status-待受理 {
  background: rgba(255, 165, 0, 0.2);
  color: #FFA500;
}

.status-处理中 {
  background: rgba(85, 137, 242, 0.2);
  color: #5589F2;
}

.status-已办结 {
  background: rgba(0, 212, 170, 0.2);
  color: #00D4AA;
}

.supervision-warning-content {
  font-size: 12px;
  color: rgba(96, 98, 102, 0.9);
  line-height: 1.6;
  margin-bottom: 6px;
}

.supervision-warning-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.warning-type {
  font-size: 11px;
  color: rgba(96, 98, 102, 0.6);
  padding: 2px 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.warning-type.negative-type {
  background: rgba(229, 63, 49, 0.2);
  color: #E53F31;
}

.warning-party {
  font-size: 11px;
  color: rgba(96, 98, 102, 0.5);
}

.warning-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.generate-workorder-btn {
  padding: 6px 12px;
  background: linear-gradient(135deg, #E53F31 0%, #C0392B 100%);
  border: none;
  border-radius: 4px;
  color: #606266;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.generate-workorder-btn:hover {
  background: linear-gradient(135deg, #F05F4F 0%, #D0493B 100%);
}

.export-button-container {
  margin-top: 16px;
  flex-shrink: 0;
}

.export-button {
  width: 100%;
  padding: 10px;
  background: linear-gradient(135deg, #5589F2 0%, #3F66FF 100%);
  border: none;
  border-radius: 6px;
  color: #606266;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.export-button:hover {
  background: linear-gradient(135deg, #6699FF 0%, #5575FF 100%);
}

.keyword-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
}

.keyword-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.keyword-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 600px;
  max-height: 80vh;
  transform: translate(-50%, -50%);
  padding: 18px 18px 16px;
  box-sizing: border-box;
  z-index: 1001;
}

.keyword-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.keyword-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #606266;
}

.keyword-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: #000;
  font-size: 28px;
  cursor: pointer;
}

.keyword-modal-body {
  height: 300px;
  display: flex;
  flex-direction: column;
}

.keyword-modal-table-header {
  display: flex;
  padding: 12px 16px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px 4px 0 0;
}

.keyword-modal-table-scroll {
  flex: 1;
  overflow-y: auto;
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-top: none;
  border-radius: 0 0 4px 4px;
}

.keyword-modal-table-header span {
  flex: 1;
  text-align: center;
  font-weight: 600;
  color: #606266;
  font-size: 14px;
}

.keyword-modal-table-header span:last-child {
  flex: 0.8;
}

.keyword-modal-table-body {
  padding: 0;
}

.keyword-modal-table-row {
  display: flex;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
  align-items: center;
  justify-content: center;
  background: rgba(11, 27, 88, 0.52);
}

.keyword-modal-table-row.keyword-disabled {
  opacity: 0.5;
}

.keyword-modal-table-row:last-child {
  border-bottom: none;
}

.keyword-modal-table-row>span {
  flex: 1;
  text-align: center;
  color: rgba(96, 98, 102, 0.86);
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.keyword-modal-table-row>span:last-child {
  flex: 0.8;
}

.keyword-modal-table-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.keyword-modal-table-actions a {
  color: #4cd9ff;
  text-decoration: none;
  font-size: 13px;
}

.keyword-modal-table-actions a:hover {
  text-decoration: underline;
}

.keyword-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.keyword-modal-add-btn {
  padding: 10px 40px;
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  border: none;
  border-radius: 4px;
  color: #606266;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.keyword-modal-add-btn:hover {
  background: linear-gradient(135deg, #6ce5ff 0%, #00c8f0 100%);
}

.export-modal {
  position: fixed;
  inset: 0;
  z-index: 1004;
}

.export-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.export-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 480px;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
}

.export-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
}

.export-modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #606266;
}

.export-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: #000;
  font-size: 24px;
  cursor: pointer;
  border-radius: 50%;
}

.export-modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

.export-modal-body {
  padding: 8px 0;
}

.export-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.export-form-item:last-child {
  margin-bottom: 0;
}

.export-form-label {
  font-size: 14px;
  color: rgba(96, 98, 102, 0.6);
  min-width: 80px;
  flex-shrink: 0;
}

.export-date-range {
  display: flex;
  align-items: center;
  gap: 8px;
}

.export-date-input {
  padding: 8px 12px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(96, 98, 102, 0.9);
  font-size: 14px;
  outline: none;
}

.export-date-input:hover {
  border-color: rgba(76, 165, 255, 0.5);
}

.export-date-input:focus {
  border-color: #4cd9ff;
  box-shadow: 0 0 0 2px rgba(76, 217, 255, 0.2);
}

.date-separator {
  color: rgba(96, 98, 102, 0.6);
  font-size: 14px;
}

.export-select {
  flex: 1;
  padding: 8px 12px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(96, 98, 102, 0.9);
  font-size: 14px;
  cursor: pointer;
  outline: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='rgba(255,255,255,0.6)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
}

.export-select:hover {
  border-color: rgba(76, 165, 255, 0.5);
}

.export-select:focus {
  border-color: #4cd9ff;
  box-shadow: 0 0 0 2px rgba(76, 217, 255, 0.2);
}

.export-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.export-modal-cancel-btn {
  padding: 8px 24px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: rgba(96, 98, 102, 0.86);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.export-modal-cancel-btn:hover {
  background: rgba(17, 45, 132, 0.72);
}

.export-modal-confirm-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  border: none;
  border-radius: 4px;
  color: #606266;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.export-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #6ce5ff 0%, #00c8f0 100%);
}

.tip-modal {
  position: fixed;
  inset: 0;
  z-index: 2000;
}

.tip-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.tip-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 400px;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
}

.tip-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
}

.tip-modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #606266;
}

.tip-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: #000;
  font-size: 24px;
  cursor: pointer;
  border-radius: 50%;
}

.tip-modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

.tip-modal-body {
  padding: 8px 0;
}

.tip-modal-message {
  font-size: 14px;
  color: rgba(96, 98, 102, 0.9);
  line-height: 1.6;
}

.tip-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.tip-modal-confirm-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  border: none;
  border-radius: 4px;
  color: #606266;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.tip-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #6ce5ff 0%, #00c8f0 100%);
}

.confirm-modal {
  position: fixed;
  inset: 0;
  z-index: 1002;
}

.confirm-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.confirm-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 500px;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
}

.confirm-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
}

.confirm-modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #606266;
}

.confirm-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: #000;
  font-size: 24px;
  cursor: pointer;
  border-radius: 50%;
}

.confirm-modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

.confirm-modal-body {
  padding: 8px 0;
}

.confirm-modal-info {
  background: rgba(11, 27, 88, 0.52);
  border-radius: 6px;
  padding: 16px;
}

.confirm-info-item {
  display: flex;
  margin-bottom: 12px;
  align-items: flex-start;
}

.confirm-info-item:last-child {
  margin-bottom: 0;
}

.confirm-info-label {
  font-size: 14px;
  color: rgba(96, 98, 102, 0.6);
  min-width: 70px;
  flex-shrink: 0;
}

.confirm-info-value {
  font-size: 14px;
  color: rgba(96, 98, 102, 0.9);
  flex: 1;
  word-break: break-all;
}

.confirm-select {
  flex: 1;
  padding: 8px 12px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(96, 98, 102, 0.9);
  font-size: 14px;
  cursor: pointer;
  outline: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='rgba(255,255,255,0.6)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
}

.confirm-select:hover {
  border-color: rgba(76, 165, 255, 0.5);
}

.confirm-select:focus {
  border-color: #4cd9ff;
  box-shadow: 0 0 0 2px rgba(76, 217, 255, 0.2);
}

.confirm-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.confirm-modal-cancel-btn {
  padding: 8px 24px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: rgba(96, 98, 102, 0.86);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.confirm-modal-cancel-btn:hover {
  background: rgba(17, 45, 132, 0.72);
}

.confirm-modal-confirm-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #E53F31 0%, #C0392B 100%);
  border: none;
  border-radius: 4px;
  color: #606266;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.confirm-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #F05F4F 0%, #D0493B 100%);
}

.keyword-edit-modal {
  position: fixed;
  inset: 0;
  z-index: 1002;
}

.keyword-edit-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.keyword-edit-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 400px;
  transform: translate(-50%, -50%);
  padding: 18px 18px 16px;
  box-sizing: border-box;
  z-index: 1003;
}

.keyword-edit-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.keyword-edit-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #606266;
}

.keyword-edit-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: #000;
  font-size: 28px;
  cursor: pointer;
}

.keyword-edit-modal-body {
  padding: 0;
}

.keyword-edit-form-item {
  margin-bottom: 16px;
}

.keyword-edit-form-item label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: rgba(96, 98, 102, 0.86);
  font-weight: 500;
}

.keyword-edit-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
  background: rgba(11, 27, 88, 0.52);
  color: rgba(96, 98, 102, 0.86);
}

.keyword-edit-input:focus {
  outline: none;
  border-color: #4cd9ff;
}

.keyword-edit-input::placeholder {
  color: rgba(96, 98, 102, 0.4);
}

.keyword-edit-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.keyword-edit-modal-cancel-btn {
  padding: 8px 24px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: rgba(96, 98, 102, 0.86);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.keyword-edit-modal-cancel-btn:hover {
  background: rgba(17, 45, 132, 0.72);
}

.keyword-edit-modal-confirm-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  border: none;
  border-radius: 4px;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.keyword-edit-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #6ce5ff 0%, #00c8f0 100%);
}

.keyword-batch-import-modal {
  position: fixed;
  inset: 0;
  z-index: 1003;
}

.keyword-batch-import-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
}

.keyword-batch-import-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 500px;
  transform: translate(-50%, -50%);
  padding: 18px 18px 16px;
  box-sizing: border-box;
}

.keyword-batch-import-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.keyword-batch-import-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #606266;
}

.keyword-batch-import-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: #000;
  font-size: 28px;
  cursor: pointer;
}

.keyword-batch-import-modal-close:hover {
  color: #606266;
}

.keyword-batch-import-modal-body {
  padding: 0;
}

.batch-import-tip {
  font-size: 13px;
  color: #000;
  margin-bottom: 12px;
}

.batch-import-textarea {
  width: 100%;
  height: 200px;
  padding: 12px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: #606266;
  font-size: 14px;
  resize: none;
  box-sizing: border-box;
}

.batch-import-textarea::placeholder {
  color: rgba(96, 98, 102, 0.3);
}

.keyword-batch-import-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.keyword-batch-import-modal-cancel-btn {
  padding: 8px 24px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
}

.keyword-batch-import-modal-cancel-btn:hover {
  background: rgba(17, 45, 132, 0.72);
}

.keyword-batch-import-modal-confirm-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  border: none;
  border-radius: 4px;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
}

.keyword-batch-import-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #6ce5ff 0%, #00c8f0 100%);
}

.keyword-modal-import-btn {
  padding: 6px 16px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: #606266;
  font-size: 13px;
  cursor: pointer;
  margin-right: 12px;
}

.keyword-modal-import-btn:hover {
  background: rgba(17, 45, 132, 0.72);
}

.warning-record {
  position: absolute;
  top: 28px;
  left: 486px;
  z-index: 3;
  width: 236px;
  padding: 12px 16px;
  box-sizing: border-box;
  background: rgba(11, 24, 112, 0.88);
  border: 1px solid rgba(82, 150, 255, 0.3);
}

.warning-record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #606266;
  font-size: 13px;
  font-weight: 600;
}

.sentiment-detail-panel {
  position: fixed;
  top: 110px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1004;
  width: 80%;
  max-width: 1000px;
  max-height: 70vh;
}

.sentiment-detail-panel-dialog {
  padding: 18px 18px 16px;
  box-sizing: border-box;
}

.sentiment-detail-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.sentiment-detail-panel-title {
  font-size: 22px;
  font-weight: 700;
  color: #606266;
}

.sentiment-detail-panel-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: #000;
  font-size: 28px;
  cursor: pointer;
}

.sentiment-detail-panel-body {
  padding: 16px;
  background: rgba(11, 27, 88, 0.52);
  border-radius: 4px;
  max-height: calc(70vh - 80px);
  overflow-y: auto;
}

.sentiment-detail-header {
  text-align: center;
  margin-bottom: 16px;
}

.sentiment-detail-title {
  font-size: 18px;
  font-weight: 700;
  color: #606266;
}

.sentiment-detail-info {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
}

.info-item {
  font-size: 14px;
  color: rgba(96, 98, 102, 0.86);
}

.info-label {
  color: rgba(96, 98, 102, 0.5);
  margin-right: 4px;
}

.sentiment-detail-url {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
}

.url-label {
  font-size: 14px;
  color: rgba(96, 98, 102, 0.5);
  margin-right: 8px;
}

.url-link {
  font-size: 14px;
  color: #4cd9ff;
  text-decoration: none;
  word-break: break-all;
}

.url-link:hover {
  text-decoration: underline;
}

.sentiment-detail-content {
  margin-top: 16px;
}

.content-label {
  font-size: 14px;
  color: rgba(96, 98, 102, 0.5);
  margin-bottom: 8px;
}

.content-text {
  font-size: 14px;
  color: rgba(96, 98, 102, 0.86);
  line-height: 1.8;
  padding: 12px;
  background: rgba(3, 10, 69, 0.92);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  min-height: 200px;
}

.supervision-warning-item {
  cursor: pointer;
  transition: all 0.3s;
}

.supervision-warning-item:hover {
  background: rgba(65, 100, 200, 0.45);
}

.monitor-panel {
  padding: 20px 18px 16px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.monitor-title {
  font-size: 20px;
  font-weight: 700;
  color: #606266;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-text {
  flex: 1;
}

.maintenance-btn-mini {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  background: rgba(0, 212, 255, 0.15);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.maintenance-btn-mini:hover {
  background: rgba(0, 212, 255, 0.25);
  border-color: rgba(0, 212, 255, 0.5);
}

.maintenance-btn-mini.active {
  background: rgba(0, 212, 255, 0.3);
  border-color: rgba(0, 212, 255, 0.6);
}

.mini-icon {
  font-size: 14px;
}

.mini-badge {
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  padding: 0 5px;
  background: #ff6b6b;
  color: #606266;
  font-size: 11px;
  font-weight: 600;
  border-radius: 9px;
  text-align: center;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #8cefff;
  margin-bottom: 12px;
}

.filter-section {
  margin-bottom: 20px;
}

.filter-row {
  display: flex;
  gap: 12px;
}

.filter-item {
  flex: 1;
}

.filter-label {
  font-size: 12px;
  color: rgba(96, 98, 102, 0.6);
  margin-bottom: 6px;
  display: block;
}

.filter-select-box {
  position: relative;
}

.filter-select {
  width: 100%;
  padding: 8px 32px 8px 12px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(96, 98, 102, 0.9);
  font-size: 13px;
  cursor: pointer;
  outline: none;
  appearance: none;
}

.filter-select:hover {
  border-color: rgba(76, 165, 255, 0.5);
}

.select-arrow {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(96, 98, 102, 0.5);
  font-size: 10px;
  pointer-events: none;
}

.screen-section {
  margin-bottom: 20px;
}

.screen-buttons {
  display: flex;
  gap: 8px;
}

.screen-btn {
  flex: 1;
  padding: 8px 0;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(96, 98, 102, 0.86);
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.screen-btn:hover {
  border-color: #4cd9ff;
  background: rgba(76, 217, 255, 0.1);
}

.screen-btn.active {
  background: linear-gradient(135deg, #6fb8ff 0%, #00d4aa 100%);
  border-color: transparent;
  color: #141439;
  font-weight: 600;
}

.timeline-section {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.timeline-list {
  height: calc(100% - 28px);
  overflow-y: auto;
}

.timeline-list::-webkit-scrollbar {
  width: 4px;
}

.timeline-list::-webkit-scrollbar-track {
  background: transparent;
}

.timeline-list::-webkit-scrollbar-thumb {
  background: rgba(85, 137, 242, 0.5);
  border-radius: 2px;
}

/* 景区折叠分组 */
.region-group {
  margin-bottom: 4px;
}

.region-header {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  transition: all 0.2s;
  user-select: none;
}

.region-header:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.region-expanded {
  background: #eff6ff;
  border-color: #93c5fd;
  border-radius: 6px 6px 0 0;
}

.region-arrow {
  font-size: 11px;
  color: #9ca3af;
  margin-right: 8px;
  width: 12px;
}

.region-name {
  flex: 1;
  font-size: 13px;
  color: #111827;
  font-weight: 500;
}

.region-count {
  font-size: 11px;
  color: #059669;
  background: #ecfdf5;
  padding: 1px 8px;
  border-radius: 10px;
  margin-right: 6px;
}

.region-event-count {
  font-size: 11px;
  color: #fff !important;
  background: #ef4444 !important;
  padding: 1px 8px;
  border-radius: 10px;
  font-weight: 600;
}

.region-body {
  padding: 4px 0 4px 20px;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 6px 6px;
  background: #fff;
}

.region-events {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed #e5e7eb;
}

.events-title {
  font-size: 11px;
  color: #d97706;
  padding: 2px 0 4px 0;
  font-weight: 500;
}

.timeline-item {
  display: flex;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px dashed rgba(76, 165, 255, 0.1);
}

.timeline-item:last-child {
  border-bottom: none;
}

.timeline-time {
  font-size: 11px;
  color: rgba(96, 98, 102, 0.5);
  width: 80px;
  flex-shrink: 0;
}

.timeline-dot {
  width: 8px;
  height: 8px;
  background: #4cd9ff;
  border-radius: 50%;
  margin: 0 10px;
  flex-shrink: 0;
}

.timeline-content {
  font-size: 12px;
  color: #606266;
  cursor: pointer;
}

.timeline-item:hover {
  background-color: rgba(76, 165, 255, 0.1);
}

/* 事件类型标记 */
.timeline-dot.dot-congestion {
  background: #ff6b6b;
  box-shadow: 0 0 6px rgba(255, 107, 107, 0.6);
}

.timeline-dot.dot-fault {
  background: #ffa502;
  box-shadow: 0 0 6px rgba(255, 165, 2, 0.6);
}

.timeline-dot.dot-normal {
  background: #4cd9ff;
}

/* 监控点位状态 */
.timeline-dot.dot-online {
  background: #67c23a;
  box-shadow: 0 0 6px rgba(103, 194, 58, 0.6);
}

.timeline-dot.dot-offline {
  background: rgba(96, 98, 102, 0.3);
}

/* 数据传输通道状态 */
.timeline-dot.status-normal {
  background: #67c23a;
  box-shadow: 0 0 6px rgba(103, 194, 58, 0.6);
}

.timeline-dot.status-abnormal {
  background: #ffa502;
  box-shadow: 0 0 6px rgba(255, 165, 2, 0.6);
}

.timeline-dot.status-offline {
  background: rgba(96, 98, 102, 0.3);
}

/* 视频回放弹窗 */
.video-playback-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

.modal-content {
  position: relative;
  width: 80%;
  max-width: 900px;
  background: rgba(3, 10, 69, 1);
  border: 1px solid rgba(80, 220, 255, 0.3);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 30px rgba(78, 240, 228, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(80, 220, 255, 0.2);
}

.playback-modal .modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.modal-close {
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(255, 255, 255, 0.1);
  color: #606266;
  font-size: 20px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.2);
}

.modal-body {
  padding: 20px;
}

/* 新弹窗布局样式 */
.modal-content.playback-modal {
  max-width: 1200px;
  width: 90%;
  background: #fff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.modal-content.point-modal {
  max-width: 1100px;
  width: 90%;
  background: #fff;
  border-radius: 8px;
}

.modal-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid #e5e7eb;
}

.point-modal .modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.modal-close-btn {
  width: 30px;
  height: 30px;
  border: none;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 14px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close-btn:hover {
  background: #e5e7eb;
  color: #374151;
}

.close-icon {
  font-weight: 400;
}

/* 事件回放弹窗布局 */
.modal-body-grid {
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 24px;
  padding: 24px;
  height: calc(100vh - 200px);
  overflow: hidden;
}

.main-content-area {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.video-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.video-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.video-label {
  font-size: 13px;
  color: #374151;
  font-weight: 500;
}

.video-duration {
  font-size: 12px;
  color: #9ca3af;
}

.video-wrapper video {
  flex: 1;
  width: 100%;
  object-fit: contain;
}

.side-panel {
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
}

.info-card,
.export-card {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.card-header {
  padding: 12px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.card-title {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

.card-body {
  padding: 16px;
}

.detail-item {
  margin-bottom: 16px;
}

.detail-item:last-child {
  margin-bottom: 0;
}

.detail-label {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 6px;
}

.detail-value {
  font-size: 14px;
  color: #111827;
}

.detail-value-wrapper {
  margin-top: 6px;
}

.detail-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.detail-badge.type-congestion {
  background: #fef2f2;
  color: #dc2626;
}

.detail-badge.type-fault {
  background: #fffbeb;
  color: #d97706;
}

.export-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-label {
  font-size: 12px;
  color: #6b7280;
}

.datetime-input {
  width: 100%;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  color: #111827;
  font-size: 13px;
  outline: none;
  transition: border-color 0.2s;
}

.datetime-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.export-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: #3b82f6;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.export-button:hover {
  background: #2563eb;
}

/* 点位视频弹窗布局 */
.modal-body-container {
  display: grid;
  grid-template-columns: 1fr 280px;
  gap: 20px;
  padding: 20px;
  height: calc(100vh - 200px);
  overflow: hidden;
}

.video-main-area {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.video-stats-bar {
  display: flex;
  gap: 24px;
  padding: 10px 16px;
  background: #f9fafb;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.stat-label {
  font-size: 12px;
  color: #9ca3af;
}

.stat-value {
  font-size: 13px;
  color: #374151;
  font-weight: 500;
}

.status-online-text {
  color: #059669;
}

.status-offline-text {
  color: #dc2626;
}

.video-display-area {
  flex: 1;
  position: relative;
  background: #111827;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.point-video-player {
  width: 100%;
  height: 100%;
}

.video-controls-overlay {
  position: absolute;
  top: 10px;
  left: 10px;
}

.live-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  background: #dc2626;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.5px;
}

.video-display-area.offline-state {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
}

.offline-display {
  text-align: center;
}

.offline-title {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}

.offline-desc {
  font-size: 13px;
  color: #9ca3af;
}

.info-sidebar {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-panel {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  flex: 1;
}

.panel-header {
  padding: 10px 14px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.panel-title {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}

.panel-content {
  padding: 4px 14px;
}

.info-row-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f3f4f6;
}

.info-row-item:last-child {
  border-bottom: none;
}

.info-row-item .info-label {
  font-size: 13px;
  color: #6b7280;
}

.info-row-item .info-value {
  font-size: 13px;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
}

.dot-online {
  background: #059669;
}

.dot-offline {
  background: #9ca3af;
}

.action-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.action-btn.primary {
  background: #3b82f6;
  color: #fff;
}

.action-btn.primary:hover {
  background: #2563eb;
}

.action-btn.secondary {
  background: #fff;
  border: 1px solid #d1d5db;
  color: #374151;
}

.action-btn.secondary:hover {
  background: #f9fafb;
}

.playback-info {
  margin-bottom: 20px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}

.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-label {
  font-size: 13px;
  color: rgba(96, 98, 102, 0.6);
  width: 100px;
}

.info-value {
  font-size: 13px;
  color: #606266;
}

.info-value.type-congestion {
  color: #ff6b6b;
}

.info-value.type-fault {
  color: #ffa502;
}

.video-container {
  margin-bottom: 20px;
  background: #000;
  border-radius: 6px;
  overflow: hidden;
  height: 400px;
}

.point-video-container {
  width: 100%;
  height: 100%;
}

.offline-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  background: #1a1a1a;
}

.offline-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.offline-icon {
  font-size: 60px;
}

.offline-text {
  font-size: 18px;
  color: #ff4d4f;
  font-weight: bold;
}

.playback-video {
  width: 100%;
  height: 400px;
  object-fit: contain;
}

/* 点位视频播放弹窗 */
.point-video-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.point-video-modal .modal-content.video-modal {
  max-width: 1000px;
}

.point-video-player {
  width: 100%;
  height: 500px;
  object-fit: contain;
}

.video-info {
  margin-top: 15px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}

.video-info .info-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.video-info .info-row:last-child {
  margin-bottom: 0;
}

.video-info .info-label {
  color: #000;
  font-size: 14px;
  width: 60px;
}

.video-info .info-value {
  color: #000;
  font-size: 14px;
}

.video-info .status-online {
  color: #52c41a;
}

.video-info .status-offline {
  color: #ff4d4f;
}

.modal-icon {
  margin-right: 8px;
}

.export-section {
  padding: 15px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}

.export-title {
  font-size: 14px;
  font-weight: 500;
  color: #000;
  margin-bottom: 15px;
}

.time-range-selector {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.range-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.range-label {
  font-size: 13px;
  color: #000;
}

.time-input {
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(80, 220, 255, 0.3);
  border-radius: 4px;
  color: #606266;
  font-size: 13px;
}

.export-btn {
  padding: 8px 20px;
  background: linear-gradient(135deg, #00d4ff, #0099cc);
  border: none;
  color: #606266;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
}

.export-btn:hover {
  background: linear-gradient(135deg, #00e5ff, #00a8dd);
  transform: translateY(-1px);
}

.screen-preview-panel {
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
}

.screen-grid {
  flex: 1;
  display: grid;
  padding: 12px 6px;
  overflow-y: auto;
}

.screen-grid::-webkit-scrollbar {
  width: 4px;
}

.screen-grid::-webkit-scrollbar-track {
  background: transparent;
}

.screen-grid::-webkit-scrollbar-thumb {
  background: rgba(85, 137, 242, 0.5);
  border-radius: 2px;
}

.screen-grid-item {
  aspect-ratio: 16 / 9;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.screen-video-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.screen-video-title {
  padding: 4px 8px;
  font-size: 11px;
  color: rgba(96, 98, 102, 0.8);
  background: rgba(0, 0, 0, 0.3);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.screen-video-body {
  flex: 1;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
  min-height: 0;
}

.screen-video {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  box-sizing: border-box;
  object-fit: fill;
  background-color: #000;
  border-radius: 2px;
}

.screen-info {
  text-align: center;
  padding-top: 12px;
  font-size: 14px;
  color: #8cefff;
  font-weight: 600;
  border-top: 1px solid rgba(76, 165, 255, 0.2);
}

/* 监控列表样式 */
.monitor-list {
  display: none;
  margin-top: 12px;
  border-top: 1px solid rgba(76, 165, 255, 0.2);
}

.monitor-list.show {
  display: block;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: rgba(76, 165, 255, 0.1);
}

.list-title {
  font-size: 13px;
  color: #8cefff;
  font-weight: 600;
}

.list-count {
  font-size: 12px;
  color: rgba(96, 98, 102, 0.6);
}

.list-content {
  max-height: 200px;
  overflow-y: auto;
}

.list-content::-webkit-scrollbar {
  width: 4px;
}

.list-content::-webkit-scrollbar-track {
  background: rgba(76, 165, 255, 0.1);
}

.list-content::-webkit-scrollbar-thumb {
  background: rgba(76, 165, 255, 0.5);
  border-radius: 2px;
}

.list-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.1);
  cursor: pointer;
  transition: all 0.2s;
}

.list-item:hover {
  background: rgba(76, 165, 255, 0.15);
}

.point-status {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 10px;
}

.point-status.status-online {
  background: #00ff88;
  box-shadow: 0 0 6px rgba(0, 255, 136, 0.6);
}

.point-status.status-offline {
  background: #666;
}

.point-status.status-error {
  background: #ff4757;
  box-shadow: 0 0 6px rgba(255, 71, 87, 0.6);
}

.point-info {
  flex: 1;
  min-width: 0;
}

.point-name {
  font-size: 13px;
  color: rgba(96, 98, 102, 0.9);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.point-detail {
  font-size: 11px;
  color: rgba(96, 98, 102, 0.5);
  margin-top: 2px;
}

.point-action {
  padding: 4px;
}

.play-icon {
  font-size: 10px;
  color: #8cefff;
}

.empty-tip {
  text-align: center;
  padding: 20px;
  font-size: 13px;
  color: rgba(96, 98, 102, 0.5);
}

/* 屏幕标签样式 */
.screen-label {
  position: absolute;
  bottom: 4px;
  left: 4px;
  padding: 2px 6px;
  font-size: 11px;
  color: #606266;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 8px);
}

/* 拖拽相关样式 */
.list-item[draggable="true"] {
  cursor: grab;
}

.list-item[draggable="true"]:hover {
  background: rgba(76, 165, 255, 0.2);
}

.list-item[draggable="true"]:active {
  cursor: grabbing;
}

.list-item.dragging {
  opacity: 0.6;
}

/* B 公司白色系视频监控覆盖 */
.page-container,
.warning-main {
  background: linear-gradient(180deg, #f7fafc 0%, #eef4f8 100%);
  color: #22313f;
}

.head {
  background: rgba(255, 255, 255, 0.96);
  color: #22313f;
  border-bottom: 1px solid rgba(34, 49, 63, 0.08);
  box-shadow: 0 10px 28px rgba(34, 49, 63, 0.08);
}

.head-title,
.type-item2 {
  color: #22313f;
}

.type-item {
  color: #526173;
}

.type-on {
  background-color: #2f80ed;
}

.date-weather,
.changeDateOne {
  background: #f6f9fc;
  background-image: none;
  border: 1px solid rgba(47, 128, 237, 0.18);
  border-radius: 6px;
  color: #2f80ed;
}

.migrateMap {
  background-color: #eef4f8;
}

.data-box,
.monitor-panel,
.maintenance-content,
.screen-preview-panel,
.modal-content {
  background-color: rgba(255, 255, 255, 1);
  background-image: none;
  border: 1px solid rgba(34, 49, 63, 0.08);
  border-radius: 8px;
  box-shadow: 0 12px 30px rgba(34, 49, 63, 0.1);
  color: #22313f;
}

.monitor-title,
.title-text,
.section-title,
.maintenance-title,
.preview-title,
.modal-title,
.channel-name,
.timeline-content,
.stats-count,
.point-name,
.info-value,
.export-title,
.offline-text {
  color: #22313f;
}

.filter-label,
.stats-label,
.channel-device,
.timeline-time,
.point-detail,
.info-label,
.empty-tip,
.screen-label {
  color: #526173;
}

.video-points-stats,
.filter-section,
.screen-section,
.timeline-section,
.channel-item,
.list-item,
.playback-info,
.video-info,
.export-section,
.time-range-selector,
.offline-container {
  background: rgba(47, 128, 237, 0.04);
  border-color: rgba(34, 49, 63, 0.08);
}

.list-item:hover,
.channel-item:hover,
.timeline-item:hover {
  background: rgba(47, 128, 237, 0.08);
}

.filter-select,
.time-input,
input,
select {
  background-color: #fff;
  border: 1px solid rgba(34, 49, 63, 0.14);
  border-radius: 6px;
  color: #22313f;
}

.screen-btn,
.maintenance-btn-mini,
.modal-close,
.maintenance-close {
  background: #f6f9fc;
  border: 1px solid rgba(34, 49, 63, 0.12);
  color: #526173;
  border-radius: 6px;
}

.screen-btn.active,
.maintenance-btn-mini.active,
.export-btn {
  background: #2f80ed;
  border-color: #2f80ed;
  color: #606266;
  box-shadow: 0 8px 18px rgba(47, 128, 237, 0.18);
}

.online-icon,
.point-status.status-online,
.channel-status-dot.status-online {
  background: #12b886;
}

.offline-icon,
.point-status.status-offline {
  background: #8a98a8;
}

.error-icon,
.point-status.status-error {
  background: #fa5252;
}

.total-icon {
  background: #2f80ed;
}

.status-online {
  color: #0f766e;
}

.status-offline {
  color: #8a98a8;
}

.status-error,
.type-warning,
.offline-icon {
  color: #c92a2a;
}

.timeline-dot {
  border-color: #fff;
}

.modal-overlay {
  background: rgba(34, 49, 63, 0.26);
}

.video-container,
.playback-video,
.point-video-container,
.video-screen,
.video-player,
.screen-cell {
  background: #0b1220;
}

.screen-label {
  background: rgba(255, 255, 255, 0.86);
  color: #22313f;
}

.list-content::-webkit-scrollbar-track {
  background: #eef4f8;
}

.list-content::-webkit-scrollbar-thumb {
  background: rgba(47, 128, 237, 0.42);
}

/* 现代后台 UI 视觉修正 */
.page-container,
.warning-main {
  --ui-bg: #f5f7fa;
  --ui-surface: #ffffff;
  --ui-surface-soft: #f9fafc;
  --ui-border: #dcdfe6;
  --ui-border-soft: #ebeef5;
  --ui-text: #1f2937;
  --ui-text-regular: #606266;
  --ui-primary: #409eff;
  --ui-success: #67c23a;
  --ui-danger: #f56c6c;
  --ui-radius: 8px;
  --ui-shadow: 0 8px 24px rgba(31, 45, 61, 0.08);
  background: var(--ui-bg);
  color: var(--ui-text);
}

.head,
.data-box,
.monitor-panel,
.maintenance-content,
.screen-preview-panel,
.modal-content {
  background: rgba(255, 255, 255, 1);
  background-image: none;
  border: 1px solid var(--ui-border-soft);
  border-radius: var(--ui-radius);
  box-shadow: var(--ui-shadow);
  color: var(--ui-text);
}

.head {
  border-radius: 0;
  box-shadow: 0 2px 10px rgba(31, 45, 61, 0.06);
}

.monitor-title,
.title-text,
.section-title,
.maintenance-title,
.preview-title,
.modal-title,
.channel-name,
.timeline-content,
.stats-count,
.point-name,
.info-value,
.export-title,
.offline-text {
  color: var(--ui-text);
  font-weight: 600;
}

.filter-label,
.stats-label,
.channel-device,
.timeline-time,
.point-detail,
.info-label,
.empty-tip,
.screen-label {
  color: var(--ui-text-regular);
}

.type-item,
.date-weather,
.changeDateOne,
.video-points-stats,
.filter-section,
.screen-section,
.timeline-section,
.channel-item,
.list-item,
.playback-info,
.video-info,
.export-section,
.time-range-selector,
.offline-container,
.screen-btn,
.maintenance-btn-mini,
.modal-close,
.maintenance-close {
  background: var(--ui-surface-soft);
  background-image: none;
  border: 1px solid var(--ui-border-soft);
  border-radius: 6px;
  color: var(--ui-text-regular);
  box-shadow: none;
}

.type-on,
.screen-btn.active,
.maintenance-btn-mini.active,
.export-btn {
  background: var(--ui-primary);
  border-color: var(--ui-primary);
  color: #606266;
  box-shadow: 0 6px 16px rgba(64, 158, 255, 0.2);
}

.filter-select,
.time-input,
input,
select {
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  color: var(--ui-text);
}

.online-icon,
.point-status.status-online,
.channel-status-dot.status-online {
  background: var(--ui-success);
}

.error-icon,
.point-status.status-error {
  background: var(--ui-danger);
}

.total-icon {
  background: var(--ui-primary);
}

.status-online {
  color: var(--ui-success);
}

.status-error,
.type-warning {
  color: var(--ui-danger);
}

.modal-overlay {
  background: rgba(31, 45, 61, 0.28);
}

/* 内容排版与文字可读性修正 */
.warning-main {
  padding: 20px 24px;
  box-sizing: border-box;
}

.warning-left {
  height: calc(100% - 40px);
  margin: 0;
}

.warning-left {
  width: 420px;
}


.data-box,
.monitor-panel,
.maintenance-content,
.screen-preview-panel,
.modal-content {
  padding: 16px;
  box-sizing: border-box;
}

.data-box *,
.monitor-panel *,
.maintenance-content *,
.screen-preview-panel *,
.modal-content * {
  text-shadow: none;
}

.data-box,
.data-box p,
.data-box span,
.data-box div,
.monitor-panel,
.monitor-panel p,
.monitor-panel span,
.monitor-panel div,
.maintenance-content,
.maintenance-content p,
.maintenance-content span,
.maintenance-content div,
.screen-preview-panel,
.screen-preview-panel p,
.screen-preview-panel span,
.screen-preview-panel div,
.modal-content,
.modal-content p,
.modal-content span,
.modal-content div {
  color: var(--ui-text-regular, #606266);
}

.monitor-title,
.title-text,
.section-title,
.maintenance-title,
.preview-title,
.modal-title,
.channel-name,
.timeline-content,
.stats-count,
.point-name,
.info-value,
.export-title,
.offline-text,
.stream-title {
  color: var(--ui-text, #1f2937);
}

.type-on,
.screen-btn.active,
.maintenance-btn-mini.active,
.export-btn {
  color: #606266;
}

.video-points-stats,
.filter-section,
.screen-section,
.timeline-section,
.channel-item,
.list-item,
.playback-info,
.video-info,
.export-section,
.time-range-selector,
.offline-container,
.video-stream-section {
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid var(--ui-border-soft, #ebeef5);
  border-radius: 8px;
}

.list-item,
.channel-item,
.timeline-item {
  min-height: 34px;
}

.video-stream-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.video-stream-item {
  margin-bottom: 0;
}

.type-on,
.screen-btn.active,
.maintenance-btn-mini.active,
.export-btn {
  background: #ecf5ff;
  border-color: #b3d8ff;
  color: #1d4f91;
  box-shadow: none;
}

.date-weather {
  background: transparent;
  border: 0;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/video-surveillance.vue